<template>

  <div class="py-4 container-fluid">
    <div class="row">

      <div class="col-md-8">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center flex-wrap gap-2">
              <p class="mb-0">Crear Produccion de Modelo</p>
              <div class="ms-auto d-flex align-items-center gap-2 flex-wrap justify-content-end">
                <argon-button variant="outline" color="secondary" size="sm" type="button"
                  @click="copyModelsListForExcel" title="Copiar modelos mismo formato Excel que remisión (sin insumos)">
                  <i class="fas fa-copy" aria-hidden="true"></i>
                </argon-button>
                <argon-button color="success" size="sm" @click="save" :disabled="isSaving">Guardar</argon-button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <p class="text-uppercase text-sm">Información</p>
            <div class="row">
              <div class="col-md-12">
                <label for="production-model-select" class="form-control-label">Modelo</label>
                <select id="production-model-select" ref="modelSelect" class="form-control select2" style="width:100%;" :disabled="isEditingProduction" required>
                  <option :value="null">Seleccione un modelo</option>
                  <option v-for="model in models" :key="model.id" :value="model.id">
                    {{ model.name }} ({{ model.ref }})
                  </option>
                </select>
              </div>

              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Observaciones - Responsable tendido</label>
                <ArgonTextarea type="text" v-model="form.description" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Fecha de terminación</label>
                <argon-input type="date" v-model="form.delivery_date" />
              </div>

              <div class="col-md-6" v-if="form.id != 0">
                <label for="example-text-input" class="form-control-label">Estado</label>
                <select name="" id="" class="form-select" v-model="form.status" @change="handleStatusChange">>
                  <option value="0">Pendiente</option>
                  <option value="1">Producción</option>
                  <option value="2">Terminado</option>
                  <option value="3">Cancelado</option>
                </select>
              </div>

              <div class="col-md-6" v-if="false && form.id != 0">
                <label for="oficio-select" class="form-control-label">Oficio</label>
                <select id="oficio-select" class="form-select" v-model="form.oficio_id" @change="handleOficioChange">
                  <option :value="null">Seleccionar oficio</option>
                  <option v-for="oficio in processes" :key="oficio.id" :value="oficio.id">
                    {{ oficio.name }}
                  </option>
                </select>
              </div>

              <div class="col-md-6" v-if="form.id != 0">
                <label for="bodega-select" class="form-control-label">Bodega</label>
                <select id="bodega-select" class="form-select" v-model="form.bodega_id" @change="handleBodegaChange">
                  <option :value="null">Seleccionar bodega</option>
                  <option v-for="bodega in bodegas" :key="bodega.id" :value="bodega.id">
                    {{ bodega.name }}
                  </option>
                </select>
              </div>

              <div class="col-md-6" v-if="form.id != 0">
                <label for="etapa-select" class="form-control-label">Etapa</label>
                <select ref="etapaSelect" id="etapa-select" class="form-select select2" style="width:100%;" v-model="form.etapa" @change="handleEtapaChange">
                  <option value="">Seleccionar etapa</option>
                  <option v-for="etapa in etapaOptions" :key="etapa" :value="etapa">{{ etapa }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4" v-if="form.id != 0">

        <div class="card mb-2" v-if="hasImages">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Imagenes</p>
            </div>
          </div>
          <div class="card-body">


            <div class="carousel-container">
              <div class="carousel-wrapper">
                <transition name="carousel-fade" mode="out-in">
                  <div class="carousel-image" :key="currentImage" v-if="insumos[currentImage] && insumos[currentImage].model && insumos[currentImage].model.first_image && insumos[currentImage].model.first_image.file_path">
                    <div class="text-center">
                      <img :src="apiUrl + insumos[currentImage].model.first_image.file_path" alt="Imagen principal"
                        class="img-fluid mb-2 w-50">
                      <br>
                      {{ insumos[currentImage].model.name }}
                    </div>
                  </div>
                </transition>
              </div>
              <button @click="prevImage" class="carousel-control-prev"><i class="fa fa-chevron-left"
                  aria-hidden="true"></i></button>
              <button @click="nextImage" class="carousel-control-next"><i class="fa fa-chevron-right"
                  aria-hidden="true"></i></button>
            </div>

          </div>
        </div>

        <div class="card mb-2">
          <div class="card-header">
            <div class="d-flex align-items-center">
              <p class="mb-0">Costo Fijo</p>

              <argon-button color="success" size="sm" class="ms-auto" @click="openModalNovelty">Agregar</argon-button>
            </div>

          </div>
          <div class="card-body pt-0">
            <div v-if="loadingNovelties" class="text-center p-4">
              <div class="spinner-border text-primary" role="status"></div>
              <p class="mt-2 text-sm text-secondary">Cargando...</p>
            </div>
            <div class="table-responsive p-0" v-if="!loadingNovelties">

              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Detalle</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">Total
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">Opciones
                    </th>

                  </tr>
                </thead>

                <tbody>
                  <tr v-for="value in novelties.data" :key="value.id">
                    <td
                      style="width: 70%; word-wrap: break-word; white-space: normal; vertical-align: top; text-align: center;">
                      <span class="text-secondary text-xs font-weight-bold">
                        <a @click="viewObservation(value.observation)"
                          class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                          data-original-title="Registro">
                          <i class="fa fa-comment"></i>
                        </a>
                      </span>

                    </td>
                    <td class="text-center">
                      <h6 class="mb-0 text-sm">{{ parseFloat(value.total ?? 0).toLocaleString('es-ES', {
                        minimumFractionDigits: 2, maximumFractionDigits: 2
                      }) }}</h6>
                    </td>

                    <td class="text-center">
                      <a @click="editRegisterNovelty(value)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                        data-original-title="Eliminar registro">
                        <i class="fa fa-pencil-alt"></i>
                      </a>

                      <a @click="deleteRegisterNovelty(value.id)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                        data-toggle="tooltip" data-original-title="Eliminar registro">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>


                  </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Tarjeta de defecto -->
        <!--  v-if="form.status != 0" -->
        <div class="card mb-2" hidden>
          <div class="card-header">
            <div class="d-flex align-items-center">
              <p class="mb-0">Registro defectuosos</p>

              <!-- <argon-button color="success" size="sm" class="ms-auto" @click="openModalDefects">Agregar</argon-button> -->
            </div>

          </div>
          <div class="card-body pt-0">

            <div class="table-responsive p-0">

              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Detalle</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">Total
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">Opciones
                    </th>

                  </tr>
                </thead>

                <tbody>
                  <tr v-for="value in novelties.data" :key="value.id">
                    <td
                      style="width: 70%; word-wrap: break-word; white-space: normal; vertical-align: top;text-align: center;">
                      <span class="text-secondary text-xs font-weight-bold">
                        <a @click="viewObservation(value.observation)"
                          class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                          data-original-title="Registro">
                          <i class="fa fa-comment"></i>
                        </a>
                      </span>
                    </td>
                    <td class="text-center">
                      <h6 class="mb-0 text-sm">{{ parseFloat(value.total ?? 0).toLocaleString('es-ES', {
                        minimumFractionDigits: 2, maximumFractionDigits: 2
                      }) }}</h6>
                    </td>

                    <td class="text-center">
                      <a @click="editRegisterDefects(value)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                        data-original-title="Eliminar registro">
                        <i class="fa fa-pencil-alt"></i>
                      </a>

                      <a @click="deleteRegisterDefects(value.id)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                        data-toggle="tooltip" data-original-title="Eliminar registro">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">

        

        <!-- Tabla modelos e insumos -->
        <div class="card mb-2" v-if="form.id != 0">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="text-uppercase mb-0">Lista de modelos e insumos</p>
              <div class="ms-auto d-flex gap-2">
                <argon-button v-if="insumos && insumos.length > 0" color="info" size="sm" @click="toggleAllAccordions">
                  {{ todosExpanded ? 'Minimizar todos' : 'Desplegar todos' }}
                </argon-button>
                <argon-button v-if="form.status == 0" color="success" size="sm" @click="openModalModel">
                  Asignar Modelo
                </argon-button>
              </div>
            </div>
          </div>

          <div class="card-body">
            <div v-if="loadingInsumos" class="text-center p-4">
              <div class="spinner-border text-primary" role="status"></div>
              <p class="mt-2 text-sm text-secondary">Cargando modelos e insumos...</p>
            </div>
            <div class="accordion" id="accordionGrupos" v-if="insumos && insumos.length > 0 && !loadingInsumos">
              <template v-for="(group, index) in insumos" :key="index">
                <div class="accordion-item mb-3">
                  <h2 class="accordion-header" :id="'heading' + index">
                    <button 
                      class="accordion-button bg-primary btn-primary" 
                      :class="{ 'collapsed': index !== 0 }"
                      type="button" 
                      :data-bs-toggle="'collapse'" 
                      :data-bs-target="'#collapse' + index"
                      :aria-expanded="index === 0 ? 'true' : 'false'"
                      :aria-controls="'collapse' + index"
                    >
                      <div class="d-flex justify-content-between align-items-center w-100 me-3">
                        <div class="d-flex align-items-center gap-2" style="flex: 1;">
                          <p style="font-size:14px;font-weight:bold;margin:0">
                            Modelo: {{ group?.model?.name }} - Talla: {{ group?.size?.size }} - Color: {{
                              group?.size?.color?.name }} ({{ group?.size?.color?.ref }}) - Cantidad: {{
                              group?.quantity_to_produce }}
                          </p>
                        </div>
                        <div class="d-flex align-items-center gap-2" @click.stop style="z-index: 10; margin-left: 10px;">
                          <a v-if="form.status == 0" @click="openModalEditModel(group)"
                            class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                            data-original-title="Editar modelo">
                            <i class="fa fa-pencil-alt"></i>
                          </a>
                          <a v-if="form.status == 0" @click="duplicateProductionModel(group)"
                            class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                            data-original-title="Duplicar modelo e insumos">
                            <i class="fa fa-copy"></i>
                          </a>
                          <a @click="openModalInsumoProduccion(group)"
                            class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                            data-original-title="Agregar insumo">
                            <i class="fa fa-plus"></i>
                          </a>
                          <a v-if="form.status == 0" @click="deleteRegister(group.id)"
                            class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                            data-original-title="Eliminar registro">
                            <i class="fa fa-trash"></i>
                          </a>
                        </div>
                      </div>
                    </button>
                  </h2>
                  <div 
                    :id="'collapse' + index" 
                    class="accordion-collapse collapse border border-primary rounded-bottom" 
                    :class="{ 'show': index === 0 }"
                    :aria-labelledby="'heading' + index"
                    data-bs-parent="#accordionGrupos"
                  >
                    <div class="accordion-body p-0">
                      <div class="mb-2 ml-3" style="margin-left: 10px;">
                        <span v-for="(oficio, oIndex) in group.oficios" :key="oIndex"
                          :class="['badge', 'badge-sm', 'bg-gradient-' + (oficio.status === 2 ? 'success' : (oficio.status === 1 ? 'warning' : 'primary'))]"
                          style="margin-right: 5px; cursor: pointer;"
                          title="Filtrar usuarios asignados"
                          @click="applyAssignedUserFiltersFromOficio(group, oficio)">
                          {{ oficio.name }}
                        </span>
                      </div>

                      <div class="table-responsive p-0">
                        <table class="table align-items-center mb-0 rounded-bottom">
                          <thead>
                            <tr>
                              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Insumo</th>
                              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                Cant<span> / Stock</span>
                              </th>
                              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                Precio</th>
                              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                Total</th>
                              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                Fecha</th>
                              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                Opciones</th>
                            </tr>
                          </thead>
                          <tbody>
                            <!-- Detalles del grupo -->
                            <tr v-for="detail in group.details" :key="detail.id" :class="{ 'table-success': detail.discounted }">
                              <td>
                                <div class="d-flex px-2 py-1">
                                  <div class="d-flex flex-column justify-content-center">
                                    <h6 class="mb-0 text-sm">
                                      {{ detail.inventory.name }} ({{ detail.inventory.ref }})
                                      <span v-if="detail.discounted" class="badge bg-success ms-2">Descontado</span>
                                    </h6>
                                  </div>
                                </div>
                              </td>
                              <td class="align-middle text-center text-sm">
                                <div v-if="form.status == 0 || form.status == 1" class="d-flex align-items-center justify-content-center gap-1">
                                  <input 
                                    type="number" 
                                    step="0.01"
                                    min="0.01"
                                    :value="detail.quantity" 
                                    @blur="updateQuantity(detail, $event)"
                                    @keyup.enter="updateQuantity(detail, $event)"
                                    class="form-control form-control-sm text-center" 
                                    style="width: 80px; display: inline-block;"
                                  />
                                  <span> / </span>
                                  <span class="badge" :class="{
                                    'bg-danger': Number(detail.inventory?.quantity || 0) < Number(detail.totalRequired || 0),
                                    'bg-secondary': Number(detail.inventory?.quantity || 0) >= Number(detail.totalRequired || 0)
                                  }">
                                    {{ Number(detail.inventory?.quantity || 0).toFixed(2) }}
                                  </span>
                                </div>
                                <div v-else>
                                  {{ detail.quantity }}
                                </div>
                              </td>
                              <td class="align-middle text-center text-sm">
                                {{ parseFloat(detail.price).toLocaleString('es-ES', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                }) }}
                              </td>
                              <td class="align-middle text-center text-sm">
                                {{ parseFloat(detail.total_price).toLocaleString('es-ES', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                }) }}
                              </td>
                              <td class="align-middle text-center">
                                <span class="text-secondary text-xs font-weight-bold">
                                  {{ new Date(detail.updated_at).toLocaleDateString('es-ES') }}
                                </span>
                              </td>
                              <td class="align-middle text-center">
                                <a @click="editModal(detail)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                                  data-toggle="tooltip" data-original-title="Editar registro">
                                  <i class="fa fa-pencil-alt"></i>
                                </a>
                                <a @click="deleteRegisterDetail(detail.id)"
                                  class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                                  style="margin-left: 15px;" data-original-title="Eliminar registro">
                                  <i class="fa fa-trash"></i>
                                </a>
                                <a @click="toggleDiscount(detail)"
                                  class="font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                                  style="margin-left: 15px;" 
                                  :class="detail.discounted ? 'text-success' : 'text-secondary'"
                                  :data-original-title="detail.discounted ? 'Desmarcar como descontado' : 'Marcar como descontado'">
                                  <i :class="detail.discounted ? 'fa fa-check-circle' : 'fa fa-circle'"></i>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>

            <div v-else-if="!loadingInsumos" class="text-center text-secondary text-sm p-4">
              No hay registros disponibles
            </div>
          </div>
        </div>

        <!-- Usuarios asignados -->
        <div class="card mb-2" v-if="form.id != 0 && form.status > 0" ref="assignedUsersSection">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center flex-wrap gap-2">
              <p class="text-uppercase mb-0">Usuarios asignados</p>
              <div class="ms-auto d-flex align-items-center gap-2 flex-wrap justify-content-end">
                <argon-button
                  v-if="form.status > 0"
                  variant="outline"
                  color="secondary"
                  size="sm"
                  type="button"
                  @click="openModalEditQuantities"
                  title="Editar cantidades entregadas"
                >
                  <i class="fas fa-edit" aria-hidden="true"></i>
                  Editar cantidades
                </argon-button>
                <argon-button color="success" v-if="form.status == 1" size="sm" @click="openModal">Asignar
                  usuario</argon-button>
              </div>
            </div>
          </div>

          <div class="card-body">
            <div v-if="loadingUsers" class="text-center p-4">
              <div class="spinner-border text-primary" role="status"></div>
              <p class="mt-2 text-sm text-secondary">Cargando usuarios asignados...</p>
            </div>
            <div class="row" v-if="!loadingUsers">
              <!-- Botones de acción masiva -->
              <div class="col-12 mb-3" v-if="selectedItems.length > 0">
                <div class="d-flex gap-2 align-items-center">
                  <span class="text-sm font-weight-bold">{{ selectedItems.length }} elemento(s) seleccionado(s)</span>
                  <argon-button 
                    v-if="canBulkMarkAsReceived"
                    color="info" 
                    size="sm" 
                    @click="bulkMarkAsReceived">
                    Marcar como Recibido
                  </argon-button>
                  <argon-button 
                    v-if="canBulkMarkAsDelivered"
                    color="warning" 
                    size="sm" 
                    @click="bulkMarkAsDelivered">
                    Marcar como Entregado
                  </argon-button>
                  <argon-button 
                    v-if="canBulkMarkAsValidated"
                    color="success" 
                    size="sm" 
                    @click="bulkMarkAsValidated">
                    Marcar como Validado
                  </argon-button>
                  <argon-button 
                    color="secondary" 
                    size="sm" 
                    @click="clearSelection">
                    Limpiar selección
                  </argon-button>
                </div>
              </div>

              <div class="col-12 mb-3">
                <div class="row g-2">
                  <div class="col-md-4">
                    <label class="form-label text-xs mb-1">Buscar usuario</label>
                    <input
                      v-model.trim="assignedUserSearch"
                      type="text"
                      class="form-control form-control-sm"
                      placeholder="Nombre del usuario"
                    />
                  </div>
                  <div class="col-md-4">
                    <label class="form-label text-xs mb-1">Filtrar por modelo</label>
                    <select v-model="assignedModelFilter" class="form-select form-select-sm">
                      <option value="">Todos los modelos</option>
                      <option v-for="model in assignedModelOptions" :key="model.id" :value="String(model.id)">
                        {{ model.label }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label text-xs mb-1">Filtrar por oficio</label>
                    <select v-model="assignedOficioFilter" class="form-select form-select-sm">
                      <option value="">Todos los oficios</option>
                      <option v-for="oficio in assignedOficioOptions" :key="oficio.id" :value="String(oficio.id)">
                        {{ oficio.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="table-responsive p-0" v-if="!loadingUsers">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        OPCIONES
                        <input 
                          v-if="selectableItemsCount > 0"
                          type="checkbox" 
                          @change="toggleSelectAll" 
                          :checked="isAllSelected"
                          style="margin-left: 10px;">
                      </th>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Usuario</th>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Modelo</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cant.
                        recibida</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cant.
                        entregada</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cant.
                        defectuosa</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha
                        asignado</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha
                        recibido</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha
                        entregado</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha
                        validado</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        observación</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total
                        ganancia</th>

                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="value in sortedUsersData" :key="value.id">
                      <td class="align-middle text-center">
                        <div style="display: flex;justify-content: center; align-items: center;gap: 10px;height: 100%;">
                          <input 
                            v-if="value.validated_date == null"
                            type="checkbox" 
                            :value="value.id"
                            :disabled="!canSelectItem(value)"
                            @change="handleCheckboxChange(value, $event)"
                            :checked="selectedItems.includes(value.id)">
                          <a @click="checkReceived(value)"
                            class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                            data-original-title="Registro" v-if="value.received_date == null">
                            <i class="fa fa-arrow-down"></i>
                          </a>


                          <a @click="checkDelivered(value)"
                            class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                            data-original-title="Eliminar registro"
                            v-if="(value.received_date != null && value.delivered_date == null) || (value.received_date != null && value.delivered_quantity < value.received_quantity)">
                            <i class="fa fa-arrow-up"></i>
                          </a>

                          <a @click="checkValidated(value)"
                            class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                            data-original-title="Eliminar registro"
                            v-if="value.delivered_date != null && value.validated_date == null && value.delivered_quantity >= value.received_quantity">
                            <i class="fa fa-check"></i>
                          </a>

                          <span style="color: forestgreen;" v-if="value.validated_date != null">
                            <i class="fa fa-check"></i>
                          </span>

                          <!-- <a @click="deleteUserRegister(value.id)"
                            class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                            data-original-title="Eliminar registro"  v-if="value.delivered_date != null && value.validated_date == null">
                            <i class="fa fa-exclamation-triangle"></i>
                          </a>
 -->

                          <a @click="deleteUserRegister(value.id)"
                            class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                            data-original-title="Eliminar registro" >
                            <i class="fa fa-trash"></i>
                          </a>

                          <a @click="generatePdf(value.id)"
                            class="text-danger font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                            data-original-title="Generar PDF">
                            <i class="fa fa-file-pdf"></i>
                          </a>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex px-2 py-1">
                          <div class="d-flex flex-column justify-content-center">
                            <h6 class="mb-0 text-sm">{{ value.user.name }}</h6>
                          </div>
                        </div>
                      </td>
                      <td class="align-middle">
                        <div class="mb-1">
                          <span class="badge badge-sm bg-gradient-primary">
                            {{ value?.oficio?.name ?? 'Sin oficio' }}
                          </span>
                        </div>
                        <div class="text-secondary text-xs font-weight-bold">
                          Talla: {{ value?.model?.size?.size ?? "Full" }}
                        </div>
                        <div class="text-secondary text-xs font-weight-bold">
                          Color: {{ value?.model?.size?.color?.name ?? "Full" }}
                        </div>
                      </td>
                      <td class="align-middle text-center">
                        <template v-if="value.received_date == null">
                          <input
                            type="text"
                            class="form-control form-control-sm text-center"
                            v-model.number="value.received_quantity"
                            @blur="handleReceivedQuantityChange(value)"
                            @keyup.enter="handleReceivedQuantityChange(value)"
                            placeholder="Ingresar cantidad"
                            style="max-width: 100px; margin: 0 auto;"
                          />
                        </template>
                        <template v-else>
                          {{ value.received_quantity }}
                        </template>
                      </td>
                      <td class="align-middle text-center">
                        <template v-if="value.received_date != null && value.delivered_date == null">
                          <input
                            type="number"
                            class="form-control form-control-sm text-center"
                            v-model.number="value.delivered_quantity"
                            @blur="handleDeliveredInput(value)"
                            @keyup.enter="handleDeliveredInput(value)"
                            :max="value.received_quantity"
                            min="0"
                            step="1"
                            placeholder="Ingresar"
                            style="max-width: 100px; margin: 0 auto;"
                          />
                        </template>
                        <template v-else>
                          {{ value.delivered_quantity }}
                        </template>
                      </td>
                      <td class="align-middle text-center">
                        {{ value.rejected_quantity }}
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ isValidDate(value.assigned_at) ? new Date(value.assigned_at).toLocaleDateString('es-ES') :
                            'Sin asignar' }}
                        </span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ isValidDate(value.received_date) ? new
                            Date(value.received_date).toLocaleDateString('es-ES') : 'Sin asignar' }}
                        </span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ isValidDate(value.delivered_date) ? new
                            Date(value.delivered_date).toLocaleDateString('es-ES') : 'Sin asignar' }}
                        </span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ isValidDate(value.validated_date) ? new
                            Date(value.validated_date).toLocaleDateString('es-ES') : 'Sin asignar' }}
                        </span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          <a @click="viewObservation(value.observation)"
                            class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                            data-original-title="Registro">
                            <i class="fa fa-comment"></i>
                          </a>
                        </span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ parseFloat(value.total).toLocaleString('es-ES', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          }) }}
                        </span>
                      </td>


                    </tr>


                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

    <!-- Modal: editar cantidades entregadas (usuarios asignados) -->
    <div class="modal fade" id="ModalEditQuantities" tabindex="-1" aria-labelledby="modalEditQuantitiesLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalEditQuantitiesLabel">Usuarios asignados</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar" @click="closeModalEditQuantities"></button>
          </div>
          <div class="modal-body">
            <div class="row g-2 mb-3">
              <div class="col-md-4">
                <label class="form-label text-xs mb-1">Buscar usuario</label>
                <input
                  v-model.trim="modalQtyUserSearch"
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="Nombre del usuario"
                />
              </div>
              <div class="col-md-4">
                <label class="form-label text-xs mb-1">Filtrar por modelo</label>
                <select v-model="modalQtyModelFilter" class="form-select form-select-sm">
                  <option value="">Todos los modelos</option>
                  <option v-for="model in assignedModelOptions" :key="model.id" :value="String(model.id)">
                    {{ model.label }}
                  </option>
                </select>
              </div>
              <div class="col-md-4">
                <label class="form-label text-xs mb-1">Filtrar por oficio</label>
                <select v-model="modalQtyOficioFilter" class="form-select form-select-sm">
                  <option value="">Todos los oficios</option>
                  <option v-for="oficio in assignedOficioOptions" :key="oficio.id" :value="String(oficio.id)">
                    {{ oficio.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0 table-sm">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Usuario</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Modelo</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cant. recibida</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" style="min-width: 9rem;">Cant. entregada</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in sortedUsersDataModal" :key="value.id">
                    <td>
                      <h6 class="mb-0 text-sm">{{ value.user?.name ?? '—' }}</h6>
                    </td>
                    <td>
                      <div class="mb-1">
                        <span class="badge badge-sm bg-gradient-primary">
                          {{ value?.oficio?.name ?? 'Sin oficio' }}
                        </span>
                      </div>
                      <div class="text-secondary text-xs font-weight-bold">
                        Talla: {{ value?.model?.size?.size ?? "Full" }}
                      </div>
                      <div class="text-secondary text-xs font-weight-bold">
                        Color: {{ value?.model?.size?.color?.name ?? "Full" }}
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ value.received_quantity }}
                    </td>
                    <td class="align-middle text-center">
                      <input
                        type="number"
                        class="form-control form-control-sm text-center"
                        style="max-width: 120px; margin: 0 auto;"
                        :min="0"
                        step="1"
                        v-model.number="value.delivered_quantity"
                        :disabled="savingDeliveredRowId === value.id"
                        @blur="persistDeliveredQuantity(value, $event)"
                        @keyup.enter="blurQtyInput($event)"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <p v-if="!sortedUsersDataModal.length" class="text-center text-secondary text-sm py-4 mb-0">
                No hay registros con los filtros aplicados.
              </p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="closeModalEditQuantities">Cerrar</button>
          </div>
        </div>
      </div>
    </div>


        <!-- Card: Insumos Utilizados -->
        <div class="card mt-2" v-if="form.id != 0">
          <div class="card-header text-center">
            <p class="mb-0">Insumos Utilizados</p>
          </div>
          <div class="card-body pt-0">
            <div v-if="loadingInsumos" class="text-center p-4">
              <div class="spinner-border text-primary" role="status"></div>
              <p class="mt-2 text-sm text-secondary">Cargando insumos utilizados...</p>
            </div>
            <div v-if="!loadingInsumos && insumosUtilizadosAgrupados.length > 0">
              <div class="table-responsive">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Insumo</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cantidad</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Precio Unitario</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Acciones
                        <div v-if="form.status == 0 || form.status == 1" class="mt-1">
                          <button class="btn btn-success btn-sm" @click="markAllInsumosAsUtilized">
                            <i class="fas fa-check-circle me-1"></i> Marcar todos
                          </button>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="insumo in insumosUtilizadosAgrupados" :key="insumo.inventory_id">
                      <td>
                        <div class="d-flex px-2 py-1">
                          <div class="d-flex flex-column justify-content-center">
                            <h6 class="mb-0 text-sm">
                              {{ insumo.inventory_name }} ({{ insumo.inventory_ref }})
                            </h6>
                          </div>
                        </div>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <div class="d-flex align-items-center justify-content-center gap-1">
                          <input
                            v-if="form.status == 0 || form.status == 1"
                            type="number"
                            step="0.01"
                            min="0.01"
                            :value="insumo.quantity"
                            @blur="updateInsumoTotalQuantity(insumo, $event)"
                            @keyup.enter="updateInsumoTotalQuantity(insumo, $event)"
                            class="form-control form-control-sm text-center"
                            style="width: 80px; display: inline-block;"
                          />
                          <span v-else>
                            {{ parseFloat(insumo.quantity).toLocaleString('es-ES', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            }) }}
                          </span>
                          <span> / </span>
                          <span class="badge" :class="{
                            'bg-danger': Number(insumo.inventory_quantity || 0) < Number(insumo.quantity || 0),
                            'bg-secondary': Number(insumo.inventory_quantity || 0) >= Number(insumo.quantity || 0)
                          }">
                            {{ Number(insumo.inventory_quantity || 0).toFixed(2) }}
                          </span>
                        </div>
                      </td>
                      <td class="align-middle text-center text-sm">
                        {{ parseFloat(insumo.price).toLocaleString('es-ES', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }) }}
                      </td>
                      <td class="align-middle text-center text-sm">
                        {{ parseFloat(insumo.total_price).toLocaleString('es-ES', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }) }}
                      </td>
                      <td class="align-middle text-center">
                        <a
                          @click="markAllInsumoAsDiscounted(insumo.inventory_id, insumo.inventory_name)"
                          class="font-weight-bold text-xs cursor-pointer"
                          data-toggle="tooltip"
                          :class="isAllInsumoDiscounted(insumo.inventory_id) ? 'text-danger' : 'text-secondary'"
                          :data-original-title="isAllInsumoDiscounted(insumo.inventory_id)
                            ? 'Los insumos ya fueron descontados del stock. Click para revertir y volver a sumar al inventario.'
                            : 'Marcar todos los modelos que usan este insumo como utilizados (descontar del stock)'"
                        >
                          <i
                            v-if="isAllInsumoDiscounted(insumo.inventory_id)"
                            class="fa fa-undo"
                          ></i>
                          <i
                            v-else
                            class="fa fa-check-circle"
                          ></i>
                          {{ isAllInsumoDiscounted(insumo.inventory_id)
                            ? 'Revertir uso'
                            : 'Marcar como utilizado'
                          }}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4" class="text-end"><strong>Total:</strong></td>
                      <td class="text-center"><strong>{{
                        parseFloat(totalInsumosUtilizados).toLocaleString('es-ES', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })
                      }}</strong></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else-if="!loadingInsumos" class="text-center text-secondary text-sm p-4">
              <p class="mb-0">No hay insumos agregados a la producción.</p>
              <p class="mb-0 text-xs mt-2">Agrega insumos en la sección "Lista de modelos e insumos" para que aparezcan aquí.</p>
            </div>
          </div>
        </div>

        <!-- Card: Factura - Resumen de Costos -->
        <div class="card mt-2" v-if="form.id != 0">
          <div class="card-header text-center">
            <p class="mb-0">Resumen de Costos</p>
          </div>
          <div class="card-body pt-0">
            <div v-if="loadingInsumos" class="text-center p-4">
              <div class="spinner-border text-primary" role="status"></div>
              <p class="mt-2 text-sm text-secondary">Cargando resumen...</p>
            </div>
            <table class="table" v-if="!loadingInsumos">
              <thead>
                <tr>
                  <th>Concepto</th>
                  <th style="text-align:center">Importe</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Total Insumos</td>
                  <td style="text-align:right">{{
                    parseFloat(totalInsumos).toLocaleString('es-ES', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })
                  }}</td>
                </tr>
                <tr>
                  <td>Total Pagado a Usuarios</td>
                  <td style="text-align:right">{{
                    parseFloat(totalPagadoUsuarios).toLocaleString('es-ES', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })
                  }}</td>
                </tr>
                <tr>
                  <td>Costo Fijo</td>
                  <td style="text-align:right">{{
                    parseFloat(totalCostoFijo).toLocaleString('es-ES', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })
                  }}</td>
                </tr>
                <tr>
                  <td><strong>Total General</strong></td>
                  <td style="text-align:right"><strong>{{
                    parseFloat(totalGeneral).toLocaleString('es-ES', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })
                      }}</strong></td>
                </tr>
                <tr>
                  <td>Total prendas</td>
                  <td style="text-align:right">{{
                    parseFloat(totalPrendas).toLocaleString('es-ES', {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0
                    })
                  }}</td>
                </tr>
                <tr>
                  <td>Costo por Unidad</td>
                  <td style="text-align:right">{{
                    parseFloat(costoPorUnidad).toLocaleString('es-ES', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })
                  }}</td>
                </tr>

                <tr>
                  <td style="vertical-align:middle">Precio de venta</td>
                  <td style="text-align:right">
                    <input type="text" class="form-control" style="text-align:right" v-model="formattedSellingCost"
                      @blur="handleSellingCostBlur" />
                  </td>
                </tr>

                <tr>
                  <td style="vertical-align:middle">Precio al mayor</td>
                  <td style="text-align:right">
                    <input type="text" class="form-control" style="text-align:right" v-model="formattedWholesalePrice"
                      @blur="handleSellingCostBlur" />
                  </td>
                </tr>

                <tr>
                  <td style="vertical-align:middle">Precio al detal</td>
                  <td style="text-align:right">
                    <input type="text" class="form-control" style="text-align:right" v-model="formattedRetailPrice"
                      @blur="handleSellingCostBlur" />
                  </td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>


      </div>


    </div>





    <!-- Modal Asignar tecnico -->
    <div class="modal fade" id="ModalBudget" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Asignar usuario</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form>

              <div class="mb-3">
                <label for="amount" class="form-label">Modelo</label>
                <select v-model="oficio_id" ref="modelUserSelect" id="modelsUser" class="form-select select2"
                  style="width:100%;">
                  <option value="0">Producción completa</option>
                  <option v-for="(group) in insumos" :key="group.id" :value="group.id">
                    Modelo: {{ group?.model?.name }} - Talla: {{ group?.size?.size }} - Color: {{
                      group?.size?.color?.name
                    }} ({{ group?.size?.color?.ref }}) - Cantidad: {{ group?.quantity_to_produce }}
                  </option>
                </select>
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Oficio</label>
                <select v-model="oficio_id" ref="processesSelect" id="oficio" class="form-select select2"
                  style="width:100%;">
                  <option v-for="process in processes" :key="process.id" :value="process.id">
                    {{ process.name }}
                  </option>
                </select>
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Usuario</label>
                <select v-model="production_user.user_id" ref="usersSelect" id="users" class="form-select select2"
                  style="width:100%;">

                  <option v-for="process in filteredUsers" :key="process.id" :value="process.id">
                    {{ process.name }}
                  </option>
                </select>
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Cantidad asignada</label>
                <input 
                  type="number" 
                  v-model.number="production_user.received_quantity" 
                  id="amount" 
                  class="form-control"
                  placeholder="Ingrese el valor"
                  :readonly="isProductionCompleteSelected"
                  :max="maxQuantityAllowed"
                  min="0"
                  step="1"
                  @input="validateQuantity"
                >
                <small class="text-muted" v-if="maxQuantityAllowed > 0">
                  Máximo permitido: {{ maxQuantityAllowed }}
                </small>
              </div>

              <div class="mb-3" v-if="fieldPayment">
                <label for="amount" class="form-label">Valor a pagar por unidad</label>
                <input type="text" v-model="formattedTotalUser" class="form-control" placeholder="Ingrese el valor">
              </div>

              <div class="mb-3" v-if="fieldPayment">
                <label for="amount" class="form-label">Valor total</label>
                <input type="text" v-model="totalPriceUser" class="form-control" placeholder="Ingrese el valor"
                  readonly>
              </div>

              <div class="mb-3" v-if="fieldPayment && benefitsOfTasks">
                <label for="benefit" class="form-label">Valor del beneficio por tarea</label>
                <input type="text" v-model="formattedBenefit" class="form-control" placeholder="Ingrese el valor del beneficio">
              </div>

              <div class="mb-3">
                <label for="example-text-input" class="form-control-label">Fecha de asignación</label>
                <argon-input type="date" v-model="production_user.assigned_at" />
              </div>

              <div class="mb-3">
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="markAsReceived"
                    v-model="markAsReceived"
                  />
                  <label class="form-check-label" for="markAsReceived">Marcar tarea como recibida</label>
                </div>
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitForm" :disabled="isSavingUser">Guardar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Asignar costo adicional -->
    <div class="modal fade" id="ModalNovelty" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Agregar costo adicional</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form>

              <div class="mb-3">
                <label for="amount" class="form-label">Valor</label>
                <input type="text" v-model="formattedTotalNovelty" class="form-control" placeholder="Ingrese el valor">
              </div>

              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Descripción</label>
                <ArgonTextarea type="text" v-model="novelty.observation" />
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalNovelty">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitFormNovelty">Guardar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Asignar costo adicional -->
    <div class="modal fade" id="ModalDefects" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Regitrar modelos defectuosos</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form>

              <div class="mb-3">
                <label for="amount" class="form-label">Valor</label>
                <input type="text" v-model="formattedTotalNovelty" class="form-control" placeholder="Ingrese el valor">
              </div>

              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Descripción</label>
                <ArgonTextarea type="text" v-model="novelty.observation" />
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalDefects">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitFormDefects">Guardar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Asignar modelo -->
    <div class="modal fade" id="ModalModel" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Asignar Modelo</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form>

              <div class="mb-3">
                <label for="amount" class="form-label">Talla - Color (Puede seleccionar múltiples)</label>
                <select v-model="oficio_id" ref="sizesSelect" id="sizes" class="form-select select2" multiple
                  style="width:100%;">
                  <option v-for="process in sizes" :key="process.id" :value="process.id">
                    Talla: {{ process.size || 'N/A' }} - Color: {{ process.color?.name || 'N/A' }} {{ process.color?.ref ? '(' + process.color.ref + ')' : '' }}
                  </option>
                </select>
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Cantidad</label>
                <input type="text" v-model="production_model.quantity_to_produce" id="amount" class="form-control"
                  placeholder="Ingrese el valor">
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Costo unitario</label>
                <input type="text" v-model="formattedPrice" class="form-control" placeholder="Ingrese el valor"
                  readonly>
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Costo total</label>
                <input type="text" v-model="totalPrice" class="form-control" placeholder="Ingrese el valor" readonly>
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalModel">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitFormModel">Guardar</button>
          </div>
        </div>
      </div>
    </div>


    <!-- Modal Agregar insumo a producción -->
    <div class="modal fade" id="ModalInsumoProduccion" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Agregar insumo</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="mb-3">
                <label for="insumosProduccionSelect" class="form-label">Insumo</label>
                <select ref="insumosProduccionSelect" id="insumosProduccionSelect" class="form-select select2" multiple style="width:100%;">
                  <option v-for="process in insumosInventory" :key="process.id" :value="process.id">
                    {{ process.name }} - ({{ process.ref }})
                  </option>
                </select>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalInsumoProduccion">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitFormInsumoProduccion">Guardar</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="ModalEditInsumo" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Editar insumo</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form>

              <div class="mb-3">
                <label class="form-label">Insumo</label>
                <select ref="insumosEditSelect" id="insumosEdit" class="form-select select2" style="width:100%;">
                  <option v-for="process in insumosInventory" :key="process.id" :value="process.id">
                    {{ process.name }} - ({{ process.ref }})
                  </option>
                </select>
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeEditModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitEditForm">Guardar</button>
          </div>
        </div>
      </div>
    </div>


  </div>

</template>



<style>
.carousel-container {
  position: relative;
  text-align: center;
  min-height: 300px;
  overflow: hidden;
}

.carousel-wrapper {
  position: relative;
  width: 100%;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-image {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Transiciones suaves para el carrusel */
.carousel-fade-enter-active {
  transition: opacity 0.6s ease-in-out, transform 0.6s ease-in-out;
}

.carousel-fade-leave-active {
  transition: opacity 0.4s ease-in-out, transform 0.4s ease-in-out;
}

.carousel-fade-enter-from {
  opacity: 0;
  transform: translateX(30px);
}

.carousel-fade-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}

.carousel-fade-enter-to,
.carousel-fade-leave-from {
  opacity: 1;
  transform: translateX(0);
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 50% !important;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: #f9b002 !important;
  border: none;
  cursor: pointer;
  padding: 10px 15px;
  border-radius: 5px;
  z-index: 10;
  transition: all 0.3s ease;
  font-size: 18px;
}

.carousel-control-prev:hover,
.carousel-control-next:hover {
  background-color: rgba(0, 0, 0, 0.8);
  transform: translateY(-50%) scale(1.15);
}

.carousel-control-prev {
  left: 10px;
}

.carousel-control-next {
  right: 10px;
}
</style>


<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonTextarea from "../../../components/ArgonTextarea.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'select2/dist/css/select2.css';
import 'select2';
import { Modal, Collapse } from 'bootstrap';

import productionUsersService from "../../../services/productionUsers.service";

const body = document.getElementsByTagName("body")[0];

export default {
  name: "Models Create",
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_IMAGE_URL,
      showMenu: false,
      isSaving: false,
      isSavingUser: false,
      todosExpanded: false,
      modalBudget: null,
      modalEditQuantities: null,
      modalQtyUserSearch: '',
      modalQtyModelFilter: '',
      modalQtyOficioFilter: '',
      modalDeliveredSnapshot: {},
      savingDeliveredRowId: null,
      modalNovelty: null,
      modalDefects: null,
      modalModel: null,
      modalInsumoProduccion: null,
      modalEdit: null,
      selectedGroup: null,
      editingProductionModelId: null,
      oficio_id: null,
      processes: [],
      isLoadingSizes: false,
      loadingInsumos: false,
      loadingUsers: false,
      loadingNovelties: false,
      lastLoadedModelId: null,
      form: {
        id: 0,
        model_id: null,
        description: '',
        status: 0,
        delivery_date: '',
        selling_cost: 0,
        wholesale_price: 0,
        retail_price: 0,
        oficio_id: null,
        bodega_id: null,
        etapa: ''
      },
      etapaOptions: [
        'tiene arreglos',
        'bodega',
        'cola de corte',
        'cola de revisado',
        'cola de despacho',
        'cola de plancha',
        'cola de dobladora',
        'cola dobladora/modista',
        'corte pediente modista',
        'modista',
        'despachado',
        'programado',
        'revisado',
        'plancha',
        'doblado'
      ],
      size: {
        size: '',
        color_id: '',
        model_id: '',
        quantity: 0,
        status: 1
      },
      filteredUsers: [],
      bodegas: [],
      models: [],
      insumos: [],
      currentImage: 0,
      insumosInventory: [],
      sizes: [],
      users: [],
      colors: [],
      purchases: [],
      purchase: {
        id: 0,
        inventory_id: 0,
        quantity: 0,
        price: 0,
        total_price: 0,
        supplier_name: ''
      },
      production_user: {
        id: 0,
        user_id: 0,
        production_models_id: 0,
        oficio_id: 0,
        production_id: 0,
        received_quantity: 0,
        delivered_quantity: 0,
        price: 0,
        benefit: 0,
        assigned_at: '',
      },
      benefitsOfTasks: false,
      production_model: {
        id: 0,
        production_id: 0,
        model_id: 0,
        size_id: 0,
        bodega_id: '',
        quantity_to_produce: 0,
        price: 0,
      },
      data: {},
      modal: {
        id: 0,
        user_id: null,
        project_id: null,
        amount: "",
        status: "active"
      },
      novelty: {
        id: 0,
        production_id: 0,
        total: 0,
        observation: ''
      },
      fieldPayment: false,
      modalEvidencia: [],
      novelties: [],
      selectedItems: [], // Array para almacenar los IDs seleccionados
      total_modal_quantity: 0,
      markAsReceived: false,
      assignedUserSearch: '',
      assignedModelFilter: '',
      assignedOficioFilter: '',
    };
  },
  components: { ArgonInput, ArgonTextarea, ArgonButton },
  computed: {
    isEditingProduction() {
      return parseInt(this.form.id) > 0;
    },
    formattedTotalNovelty: {
      get() {
        // Formatea el precio a punto de mil y sin decimales
        return Math.floor(this.novelty.total).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        // Elimina los puntos y actualiza el precio sin decimales
        this.novelty.total = parseFloat(value.replace(/\./g, "") || 0);
      },
    },
    formattedTotalUser: {
      get() {
        // Formatea el precio a punto de mil y sin decimales
        return Math.floor(this.production_user.price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        // Elimina los puntos y actualiza el precio sin decimales
        this.production_user.price = parseFloat(value.replace(/\./g, "") || 0);
      },
    },
    totalPriceUser() {
      // Calcula el total y aplica el formateo
      const total = this.production_user.received_quantity * this.production_user.price;
      return total
        ? total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        : "0";
    },
    formattedBenefit: {
      get() {
        // Formatea el beneficio a punto de mil y sin decimales
        return Math.floor(this.production_user.benefit || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        // Elimina los puntos y actualiza el beneficio sin decimales
        this.production_user.benefit = parseFloat(value.replace(/\./g, "") || 0);
      },
    },
    maxQuantityAllowed() {
      // Calcular la cantidad máxima permitida según el modelo seleccionado
      if (!this.$refs.modelUserSelect || !this.insumos || this.insumos.length === 0) {
        return 0;
      }
      
      try {
        const val = $(this.$refs.modelUserSelect).val();
        let maxCant = 0;
        
        if (parseInt(val) === 0 || val === '0' || val === null) {
          // Producción completa: suma de todas las cantidades
          maxCant = this.insumos.reduce((acc, item) => acc + (parseFloat(item.quantity_to_produce) || 0), 0);
        } else {
          // Talla específica seleccionada
          const selected = this.insumos.find(insumo => insumo.id === parseInt(val));
          maxCant = selected ? (parseFloat(selected.quantity_to_produce) || 0) : 0;
        }
        
        return maxCant;
      } catch (error) {
        console.error('Error calculando cantidad máxima:', error);
        return 0;
      }
    },
    isProductionCompleteSelected() {
      return parseInt(this.production_user.production_models_id) === 0;
    },
    formattedPrice: {
      get() {
        // Usar el precio del modelo, no del production_model
        const price = this.form.price || 0;
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
    },
    totalPrice() {
      // Calcula el total usando el precio del modelo
      // Convertir price a número (manejar formato con puntos de miles)
      let price = 0;
      if (typeof this.form.price === 'string') {
        // Si tiene punto decimal, separar parte entera y decimal
        const parts = this.form.price.split('.');
        if (parts.length > 1) {
          // El último segmento es la parte decimal, los anteriores son miles
          const decimalPart = parts[parts.length - 1];
          const integerPart = parts.slice(0, -1).join('');
          price = parseFloat(integerPart + '.' + decimalPart) || 0;
        } else {
          // Solo parte entera con puntos de miles
          price = parseFloat(this.form.price.replace(/\./g, '')) || 0;
        }
      } else {
        price = parseFloat(this.form.price) || 0;
      }
      
      // Convertir quantity a número
      let quantity = 0;
      if (typeof this.production_model.quantity_to_produce === 'string') {
        quantity = parseFloat(this.production_model.quantity_to_produce.replace(/\./g, '').replace(',', '.')) || 0;
      } else {
        quantity = parseFloat(this.production_model.quantity_to_produce) || 0;
      }
      
      const total = quantity * price;
      // Formatear el resultado con puntos de miles y mantener decimales
      if (total === 0) return "0";
      
      // Separar parte entera y decimal
      const totalStr = total.toFixed(2);
      const [integerPart, decimalPart] = totalStr.split('.');
      const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return formattedInteger + '.' + decimalPart;
    },
    formattedSellingCost: {
      get() {
        const sellingCost = Math.round(this.form.selling_cost || 0);
        return sellingCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        const numericValue = parseFloat(value.replace(/\./g, "")) || 0;
        this.form.selling_cost = numericValue;
      }
    },
    formattedWholesalePrice: {
      get() {
        const val = Math.round(this.form.wholesale_price || 0);
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        const numericValue = parseFloat(value.replace(/\./g, "")) || 0;
        this.form.wholesale_price = numericValue;
      }
    },
    formattedRetailPrice: {
      get() {
        const val = Math.round(this.form.retail_price || 0);
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        const numericValue = parseFloat(value.replace(/\./g, "")) || 0;
        this.form.retail_price = numericValue;
      }
    },
    // Suma la cantidad de insumos (elementos en el array de detalles) de todos los grupos
    totalInsumos() {
      return this.insumos.reduce((groupSum, group) => {
        return groupSum + group.details.reduce((detailSum, detail) => {
          return detailSum + parseFloat(detail.total_price);
        }, 0);
      }, 0);
    },
    // Total pagado a usuarios (valor definido en form)
    totalPagadoUsuarios() {
      return Array.isArray(this.data.data)
        ? this.data.data.reduce((sum, value) => sum + (parseFloat(value.total) || 0), 0)
        : 0;
    },
    // Total de costos fijos (tabla de costos fijos)
    totalCostosAdicionales() {
      return Array.isArray(this.novelties.data)
        ? this.novelties.data.reduce((sum, novelty) => sum + (parseFloat(novelty.total) || 0), 0)
        : 0;
    },
    totalPrendas() {
      return this.insumos.reduce((sum, group) => {
        const rawQuantity = group?.quantity_to_produce;
        const quantity = typeof rawQuantity === 'string'
          ? parseFloat(rawQuantity.replace(/\./g, '').replace(',', '.')) || 0
          : parseFloat(rawQuantity) || 0;
        return sum + quantity;
      }, 0);
    },
    // Costo Fijo: suma de la tabla de costos fijos multiplicada por el total de prendas
    totalCostoFijo() {
      return this.totalCostosAdicionales * this.totalPrendas;
    },
    // Suma de Total Insumos + Total Pagado a Usuarios + Costo Fijo
    totalGeneral() {
      return this.totalInsumos + this.totalPagadoUsuarios + this.totalCostoFijo;
    },
    // Costo por unidad: total general dividido entre el total de prendas a producir
    costoPorUnidad() {
      return this.totalPrendas ? this.totalGeneral / this.totalPrendas : 0;
    },
    // Agrupar y totalizar todos los insumos utilizados (sin necesidad de estar descontados)
    insumosUtilizadosAgrupados() {
      const agrupados = {};
      
      // Recorrer todos los grupos y sus detalles
      this.insumos.forEach(group => {
        if (group.details && Array.isArray(group.details)) {
          group.details.forEach(detail => {
            // Mostrar todos los insumos que tengan inventory_id, sin importar si están descontados
            if (detail.inventory_id) {
              const inventoryId = detail.inventory_id;
              
              // Inicializar si no existe
              if (!agrupados[inventoryId]) {
                agrupados[inventoryId] = {
                  inventory_id: inventoryId,
                  inventory_name: detail.inventory?.name || 'N/A',
                  inventory_ref: detail.inventory?.ref || '',
                  inventory_quantity: detail.inventory?.quantity || 0,
                  quantity: 0,
                  total_price: 0
                };
              }
              
              // Convertir y sumar cantidades y totales de forma más robusta
              // Usar Number() para conversión más estricta, y manejar casos null/undefined
              const quantity = Number(detail.quantity) || 0;
              const totalPrice = Number(detail.total_price) || 0;
              
              // Verificar que los valores sean números válidos antes de sumar
              if (!isNaN(quantity) && !isNaN(totalPrice)) {
                // Sumar al acumulado existente (asegurar que también sean números)
                const currentQuantity = Number(agrupados[inventoryId].quantity) || 0;
                const currentTotalPrice = Number(agrupados[inventoryId].total_price) || 0;
                
                agrupados[inventoryId].quantity = currentQuantity + quantity;
                agrupados[inventoryId].total_price = currentTotalPrice + totalPrice;
              }
            }
          });
        }
      });
      
      // Calcular precio unitario promedio para cada insumo agrupado
      Object.keys(agrupados).forEach(key => {
        const item = agrupados[key];
        const quantity = Number(item.quantity) || 0;
        const totalPrice = Number(item.total_price) || 0;
        // Calcular precio unitario promedio: total_price / quantity
        item.price = quantity > 0 ? totalPrice / quantity : 0;
        // Asegurar que quantity y total_price sean números
        item.quantity = quantity;
        item.total_price = totalPrice;
      });
      
      // Convertir objeto a array y ordenar por nombre
      const result = Object.values(agrupados).sort((a, b) => 
        a.inventory_name.localeCompare(b.inventory_name)
      );
      
      return result;
    },
    // Total general de insumos utilizados
    totalInsumosUtilizados() {
      return this.insumosUtilizadosAgrupados.reduce((sum, item) => {
        return sum + (parseFloat(item.total_price) || 0);
      }, 0);
    },
    // Verificar si hay imágenes reales para mostrar en el carrusel
    hasImages() {
      if (!this.insumos || this.insumos.length === 0) {
        return false;
      }
      return this.insumos.some(group => {
        return group.model && 
               group.model.first_image && 
               group.model.first_image.file_path;
      });
    },
    // Computed properties para selección masiva
    selectableItemsCount() {
      // Contar solo los items que no están validados
      return Array.isArray(this.data.data) 
        ? this.data.data.filter(item => item.validated_date == null).length 
        : 0;
    },
    isAllSelected() {
      // Verificar si todos los items seleccionables están seleccionados
      if (!Array.isArray(this.data.data)) return false;
      const selectableItems = this.data.data.filter(item => item.validated_date == null);
      if (selectableItems.length === 0) {
        return false;
      }
      // Si hay items seleccionados, verificar que todos los del mismo estado estén seleccionados
      if (this.selectedItems.length === 0) {
        return false;
      }
      const state = this.selectedItemsState;
      if (!state) {
        return false;
      }
      const itemsOfSameState = selectableItems.filter(item => this.getItemState(item) === state);
      return itemsOfSameState.length > 0 && itemsOfSameState.every(item => this.selectedItems.includes(item.id));
    },
    canBulkMarkAsReceived() {
      // Solo puede marcar como recibido si hay items seleccionados que no tienen received_date
      if (!Array.isArray(this.data.data)) return false;
      return this.selectedItems.length > 0 && this.data.data.some(item => 
        this.selectedItems.includes(item.id) && item.received_date == null
      );
    },
    canBulkMarkAsDelivered() {
      // Solo puede marcar como entregado si hay items seleccionados que tienen received_date pero no delivered_date
      if (!Array.isArray(this.data.data)) return false;
      return this.selectedItems.length > 0 && this.data.data.some(item => 
        this.selectedItems.includes(item.id) && item.received_date != null && item.delivered_date == null
      );
    },
    canBulkMarkAsValidated() {
      // Solo puede marcar como validado si hay items seleccionados que tienen delivered_date pero no validated_date
      if (!Array.isArray(this.data.data)) return false;
      return this.selectedItems.length > 0 && this.data.data.some(item => 
        this.selectedItems.includes(item.id) && item.delivered_date != null && item.validated_date == null
      );
    },
    selectedItemsState() {
      // Obtener el estado del primer elemento seleccionado
      if (!Array.isArray(this.data.data) || this.selectedItems.length === 0) {
        return null;
      }
      const firstSelected = this.data.data.find(item => this.selectedItems.includes(item.id));
      if (!firstSelected) {
        return null;
      }
      return this.getItemState(firstSelected);
    },
    assignedModelOptions() {
      if (!Array.isArray(this.data?.data)) return [];

      const map = new Map();
      this.data.data.forEach((item) => {
        const productionModelId = item?.production_models_id ?? item?.model?.id;
        if (!productionModelId) return;

        const modelName = item?.model?.model?.name ?? 'Sin modelo';
        const modelRef = item?.model?.model?.ref ?? '';
        const sizeName = item?.model?.size?.size ?? 'Full';
        const colorName = item?.model?.size?.color?.name ?? 'Full';
        const colorRef = item?.model?.size?.color?.ref ?? '';
        const colorSuffix = colorRef ? ` (${colorRef})` : '';

        const label = `${modelRef ? '(' + modelRef + ') ' : ''}${modelName} - Talla: ${sizeName} - Color: ${colorName}${colorSuffix}`;

        map.set(productionModelId, {
          id: productionModelId,
          name: modelName,
          label,
        });
      });

      return Array.from(map.values()).sort((a, b) => a.label.localeCompare(b.label));
    },
    assignedOficioOptions() {
      if (!Array.isArray(this.data?.data)) return [];

      const map = new Map();
      this.data.data.forEach((item) => {
        const oficioId = item?.oficio?.id;
        const oficioName = item?.oficio?.name;
        if (!oficioId || !oficioName) return;

        map.set(oficioId, {
          id: oficioId,
          name: oficioName,
        });
      });

      return Array.from(map.values()).sort((a, b) => a.name.localeCompare(b.name));
    },
    filteredUsersData() {
      if (!Array.isArray(this.data?.data)) return [];

      const search = (this.assignedUserSearch || '').toLowerCase().trim();
      const selectedModel = this.assignedModelFilter ? String(this.assignedModelFilter) : '';
      const selectedOficio = this.assignedOficioFilter ? String(this.assignedOficioFilter) : '';

      return this.data.data.filter((item) => {
        const userName = (item?.user?.name || '').toLowerCase();
        const modelId = item?.production_models_id ?? item?.model?.id ?? '';
        const oficioId = item?.oficio?.id ?? '';

        const matchesUser = !search || userName.includes(search);
        const matchesModel = !selectedModel || String(modelId) === selectedModel;
        const matchesOficio = !selectedOficio || String(oficioId) === selectedOficio;

        return matchesUser && matchesModel && matchesOficio;
      });
    },
    // Ordenar datos por estado de tarea (recibir, entregar, validar, validado)
    sortedUsersData() {
      if (!Array.isArray(this.filteredUsersData)) {
        return [];
      }
      return [...this.filteredUsersData].sort((a, b) => {
        // Función para obtener la prioridad del estado de la tarea
        const getTaskStatusPriority = (task) => {
          if (!task.received_date) {
            return 1; // Sin recibir
          } else if (!task.delivered_date) {
            return 2; // Sin entregar
          } else if (!task.validated_date) {
            return 3; // Sin validar
          } else {
            return 4; // Validado
          }
        };

        const priorityA = getTaskStatusPriority(a);
        const priorityB = getTaskStatusPriority(b);

        // Ordenar por prioridad primero
        if (priorityA !== priorityB) {
          return priorityA - priorityB;
        }

        // Si tienen la misma prioridad, ordenar por fecha de creación descendente
        const dateA = new Date(a.created_at || a.assigned_at || 0);
        const dateB = new Date(b.created_at || b.assigned_at || 0);
        if (dateB.getTime() !== dateA.getTime()) {
          return dateB.getTime() - dateA.getTime();
        }

        // Si tienen la misma fecha, ordenar por ID descendente
        return (b.id || 0) - (a.id || 0);
      });
    },

    filteredUsersDataModal() {
      if (!Array.isArray(this.data?.data)) return [];

      const search = (this.modalQtyUserSearch || '').toLowerCase().trim();
      const selectedModel = this.modalQtyModelFilter ? String(this.modalQtyModelFilter) : '';
      const selectedOficio = this.modalQtyOficioFilter ? String(this.modalQtyOficioFilter) : '';

      return this.data.data.filter((item) => {
        const userName = (item?.user?.name || '').toLowerCase();
        const modelId = item?.production_models_id ?? item?.model?.id ?? '';
        const oficioId = item?.oficio?.id ?? '';

        const matchesUser = !search || userName.includes(search);
        const matchesModel = !selectedModel || String(modelId) === selectedModel;
        const matchesOficio = !selectedOficio || String(oficioId) === selectedOficio;

        return matchesUser && matchesModel && matchesOficio;
      });
    },
    sortedUsersDataModal() {
      if (!Array.isArray(this.filteredUsersDataModal)) {
        return [];
      }
      return [...this.filteredUsersDataModal].sort((a, b) => {
        const getTaskStatusPriority = (task) => {
          if (!task.received_date) {
            return 1;
          }
          if (!task.delivered_date) {
            return 2;
          }
          if (!task.validated_date) {
            return 3;
          }
          return 4;
        };

        const priorityA = getTaskStatusPriority(a);
        const priorityB = getTaskStatusPriority(b);

        if (priorityA !== priorityB) {
          return priorityA - priorityB;
        }

        const dateA = new Date(a.created_at || a.assigned_at || 0);
        const dateB = new Date(b.created_at || b.assigned_at || 0);
        if (dateB.getTime() !== dateA.getTime()) {
          return dateB.getTime() - dateA.getTime();
        }

        return (b.id || 0) - (a.id || 0);
      });
    },

  },
  watch: {
    'form.id': function () {
      this.$nextTick(() => {
        this.syncModelSelectDisabledState();
      });
    },
    'form.bodega_id': function () {
      this.handleBodegaChange();
    },
    'form.model_id': function (newVal, oldVal) {
      this.production_model.model_id = newVal || 0;
      // Solo llamar getSizes si el valor realmente cambió y no es la inicialización
      if (newVal && newVal !== oldVal && this.lastLoadedModelId !== newVal) {
        this.getSizes();
      } else if (!newVal) {
        this.sizes = [];
        this.lastLoadedModelId = null;
      }
      // Actualizar Select2 cuando cambie el valor (sin trigger para evitar loops)
      this.$nextTick(() => {
        if (this.$refs.modelSelect) {
          const currentVal = $(this.$refs.modelSelect).val();
          if (currentVal !== String(newVal)) {
            $(this.$refs.modelSelect).val(newVal);
          }
        }
      });
    },
    'production_user.received_quantity': function (newVal) {
      // Validar la cantidad asignada comparándola con total_modal_quantity
      const cantDigitada = parseFloat(newVal) || 0;
      const totalModal = parseFloat(this.total_modal_quantity) || 0;
      
      // Si la cantidad digitada es mayor que total_modal_quantity, igualar a total_modal_quantity
      if (totalModal > 0 && cantDigitada > totalModal) {
        this.production_user.received_quantity = totalModal;
      }
    },
    'oficio_id': function () {
      // Cuando cambia el modelo seleccionado, validar la cantidad
      // Nota: Este watcher se ejecuta cuando cambia oficio_id, pero el select de modelo
      // también actualiza production_user.production_models_id en el evento change de select2
      // donde ya se llama a validateQuantity()
    },
    /* oficio_id(newVal) {
      const val = parseInt(newVal);
      if (val === 0) {
        // Suma total
        //this.production_user.received_quantity = this.insumos.reduce((acc, item) => acc + item.quantity_to_produce, 0);
      } else {
        // Solo cantidad del insumo seleccionado
        //const selected = this.insumos.find(i => i.id === val);
        //this.production_user.received_quantity = selected?.quantity_to_produce || 0;
      }
    }, */
    'insumos': {
      handler(newVal) {
        // Inicializar currentImage al primer índice con imagen válida
        if (newVal && newVal.length > 0) {
          const validIndices = this.getValidImageIndices();
          if (validIndices.length > 0 && !validIndices.includes(this.currentImage)) {
            this.currentImage = validIndices[0];
          }
        }
      },
      immediate: true
    },
  },
  methods: {
    formatProductionClipboardCurrency(value) {
      const n = parseFloat(value) || 0;
      return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    escapeProductionClipboardCell(raw) {
      if (raw == null || raw === '') {
        return '';
      }
      return String(raw).replace(/\t/g, ' ').replace(/\r?\n/g, ' ').trim();
    },
    buildProductionModelClipboardHeader() {
      const cells = [
        'Item', 'Producto', 'Nombre del Producto', 'Talla', 'Color', 'Cantidad', 'Unidad',
        'Valor Unidad','Codigo I.V.A', '% Dsc', 'IVA (%)', 'Valor I.V.A', 'Valor I.C.O', 'Valor Total', 'Descripción'
      ];
      return cells.join('\t');
    },
    /**
     * Misma secuencia de columnas que `buildRemissionDetailExportRow` en remissions/Create.vue
     * (Item, ref, nombre, talla, color, stock, cantidad, unidad PAR, precio unitario, IVA…).
     */
    buildProductionModelClipboardRow(group, itemIndex) {
      const model = group?.model || {};
      const size = group?.size || {};
      const color = size.color || {};
      const qty = parseFloat(group?.quantity_to_produce) || 0;
      const price = parseFloat(this.costoPorUnidad) || 0;
      const ivaPct = 19.00;
      const totalStored = 0;
      //const stock = group?.stock != null ? parseFloat(group.stock) : 0;
      const base = qty * price;
      let valorIVA = 0;
      if (ivaPct > 0) {
        valorIVA = Math.max(0, totalStored - base);
      }

      const productoRef = model.ref ?? '';
      const nombreProducto = model.name ?? '';
      const talla = size.size ?? '';
      const colorCode = color.ref ?? color.name ?? '';

      const cells = [
        String(itemIndex + 1),
        'REF-'+this.escapeProductionClipboardCell(productoRef),
        this.escapeProductionClipboardCell(nombreProducto),
        this.escapeProductionClipboardCell(talla),
        this.escapeProductionClipboardCell(colorCode),
        `${qty.toFixed(2)}`,
        'UN',
        this.formatProductionClipboardCurrency(price),
        ivaPct > 0 ? `${Number(ivaPct).toFixed(0)}` : '0',
        '',
        '0.00 %',
        this.formatProductionClipboardCurrency(valorIVA),
        this.formatProductionClipboardCurrency(0),
        this.formatProductionClipboardCurrency(base),
        ''
      ];

      return cells.join('\t');
    },
    /** Copia solo líneas de modelo (accordion), no insumos; mismas columnas que remisión Excel. */
    async copyModelsListForExcel() {
      const groups = Array.isArray(this.insumos) ? this.insumos : [];
      if (groups.length === 0) {
        await Swal.fire({
          icon: 'info',
          title: 'Sin modelos',
          text: 'No hay modelos asignados en esta producción para copiar.',
          confirmButtonText: 'Aceptar',
        });
        return;
      }

      const rows = [this.buildProductionModelClipboardHeader()];
      groups.forEach((group, idx) => {
        rows.push(this.buildProductionModelClipboardRow(group, idx));
      });
      const tsv = rows.join('\n');

      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(tsv);
        } else {
          const ta = document.createElement('textarea');
          ta.value = tsv;
          ta.style.position = 'fixed';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.focus();
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
        }
        await Swal.fire({
          icon: 'success',
          title: 'Copiado',
          text: 'Modelos listos para pegar en Excel (Ctrl+V).',
          timer: 2200,
          showConfirmButton: false,
        });
      } catch (e) {
        await Swal.fire({
          icon: 'error',
          title: 'No se pudo copiar',
          text: 'El navegador bloqueó el portapapeles.',
          confirmButtonText: 'Aceptar',
        });
      }
    },
    syncModelSelectDisabledState() {
      if (this.$refs.modelSelect) {
        $(this.$refs.modelSelect).prop('disabled', this.isEditingProduction);
      }
    },
    applyAssignedUserFiltersFromOficio(group, oficio) {
      const productionModelId = group?.id ?? group?.production_models_id ?? null;
      this.assignedModelFilter = productionModelId ? String(productionModelId) : '';

      let oficioId = oficio?.id ?? oficio?.oficio_id ?? null;
      if (!oficioId && oficio?.name) {
        const match = this.assignedOficioOptions.find((item) => item.name === oficio.name);
        oficioId = match?.id ?? null;
      }
      this.assignedOficioFilter = oficioId ? String(oficioId) : '';

      this.$nextTick(() => {
        const section = this.$refs.assignedUsersSection;
        if (section && typeof section.scrollIntoView === 'function') {
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    },
    validateQuantity() {
      // Validar que la cantidad asignada no exceda el máximo permitido
      if (!this.$refs.modelUserSelect) {
        return;
      }
      
      const maxAllowed = this.maxQuantityAllowed;
      const currentQuantity = parseFloat(this.production_user.received_quantity) || 0;
      
      if (maxAllowed > 0 && currentQuantity > maxAllowed) {
        this.production_user.received_quantity = maxAllowed;
      }
      
      // También validar que no sea negativa
      if (currentQuantity < 0) {
        this.production_user.received_quantity = 0;
      }
    },
    // Verificar si todos los insumos de un tipo específico están descontados
    isAllInsumoDiscounted(inventoryId) {
      if (!this.insumos || this.insumos.length === 0) {
        return false;
      }
      
      let totalDetails = 0;
      let discountedDetails = 0;
      
      this.insumos.forEach(group => {
        if (group.details && Array.isArray(group.details)) {
          group.details.forEach(detail => {
            if (detail.inventory_id === inventoryId && detail.id) {
              totalDetails++;
              const isDiscounted = detail.discounted === true || 
                                   detail.discounted === 1 || 
                                   detail.discounted === "1" || 
                                   detail.discounted === "true" ||
                                   String(detail.discounted).toLowerCase() === 'true';
              
              if (isDiscounted) {
                discountedDetails++;
              }
            }
          });
        }
      });
      
      return totalDetails > 0 && totalDetails === discountedDetails;
    },
    toggleAllAccordions() {
      this.$nextTick(() => {
        const accordion = document.getElementById('accordionGrupos');
        if (!accordion) return;

        const collapseElements = accordion.querySelectorAll('.accordion-collapse');
        
        if (this.todosExpanded) {
          // Colapsar todos y restaurar data-bs-parent para comportamiento normal
          collapseElements.forEach((element) => {
            const collapse = Collapse.getInstance(element) || new Collapse(element, { toggle: false });
            collapse.hide();
          });
          // Restaurar data-bs-parent después de un pequeño delay
          setTimeout(() => {
            collapseElements.forEach((element) => {
              element.setAttribute('data-bs-parent', '#accordionGrupos');
            });
          }, 350);
          this.todosExpanded = false;
        } else {
          // Remover data-bs-parent para permitir múltiples acordeones abiertos
          collapseElements.forEach((element) => {
            element.removeAttribute('data-bs-parent');
          });
          // Expandir todos
          collapseElements.forEach((element) => {
            const collapse = Collapse.getInstance(element) || new Collapse(element, { toggle: false });
            collapse.show();
          });
          this.todosExpanded = true;
        }
      });
    },
    nextImage() {
      const validIndices = this.getValidImageIndices();
      if (validIndices.length === 0) return;
      
      const currentIndex = validIndices.indexOf(this.currentImage);
      const nextIndex = (currentIndex + 1) % validIndices.length;
      this.currentImage = validIndices[nextIndex];
    },
    prevImage() {
      const validIndices = this.getValidImageIndices();
      if (validIndices.length === 0) return;
      
      const currentIndex = validIndices.indexOf(this.currentImage);
      const prevIndex = (currentIndex - 1 + validIndices.length) % validIndices.length;
      this.currentImage = validIndices[prevIndex];
    },
    getValidImageIndices() {
      return this.insumos
        .map((group, index) => {
          if (group.model && 
              group.model.first_image && 
              group.model.first_image.file_path) {
            return index;
          }
          return null;
        })
        .filter(index => index !== null);
    },
    editModal(detail) {
      this.purchase = {
        id: detail.id,
        inventory_id: detail.inventory_id,
        quantity: detail.quantity,
      };

      $('#insumosEdit').val(detail.inventory_id).trigger('change');
      const modalElement = document.getElementById('ModalEditInsumo');
      this.modalEdit = new Modal(modalElement); // Guarda la instancia del modal
      this.modalEdit.show(); // Muestra el modal
    },
    closeEditModal() {
      if (this.modalEdit) {
        this.modalEdit.hide(); // Cierra el modal
      }
    },
    openModalInsumoProduccion(group) {
      this.selectedGroup = group;
      const modalElement = document.getElementById('ModalInsumoProduccion');
      this.modalInsumoProduccion = new Modal(modalElement);
      this.modalInsumoProduccion.show();
      
      // Inicializar Select2 después de abrir el modal
      this.$nextTick(() => {
        if (this.$refs.insumosProduccionSelect) {
          if ($(this.$refs.insumosProduccionSelect).hasClass('select2-hidden-accessible')) {
            $(this.$refs.insumosProduccionSelect).select2('destroy');
          }
          $(this.$refs.insumosProduccionSelect).select2({
            placeholder: 'Seleccionar insumos',
            allowClear: true,
            dropdownParent: $('#ModalInsumoProduccion .modal-body'),
            width: '100%'
          });
        }
      });
    },
    closeModalInsumoProduccion() {
      if (this.modalInsumoProduccion) {
        this.modalInsumoProduccion.hide();
      }
      this.selectedGroup = null;
      if (this.$refs.insumosProduccionSelect) {
        $(this.$refs.insumosProduccionSelect).val(null).trigger('change');
      }
    },
    async submitFormInsumoProduccion() {
      try {
        const selectedInsumos = $(this.$refs.insumosProduccionSelect).val() || [];
        
        if (selectedInsumos.length === 0) {
          await Swal.fire({
            icon: 'warning',
            title: 'Atención',
            text: 'Debe seleccionar al menos un insumo.',
          });
          return;
        }

        if (!this.selectedGroup || !this.selectedGroup.id) {
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No se pudo identificar el grupo de producción.',
          });
          return;
        }

        Swal.fire({
          icon: 'info',
          title: 'Cargando...',
          text: 'Estamos guardando los insumos, por favor espera.',
          didOpen: () => {
            Swal.showLoading();
          },
          confirmButtonText: 'Aceptar',
          backdrop: true,
        });

        // Guardar cada insumo seleccionado
        const promises = selectedInsumos.map(async (inventoryId) => {
          // Buscar el inventario seleccionado para obtener su precio
          const selectedInventory = this.insumosInventory.find(inv => inv.id == inventoryId);
          const inventoryPrice = selectedInventory ? parseFloat(selectedInventory.price || 0) : 0;
          
          const purchaseData = {
            id: 0, // Importante: id debe ser 0 para crear un nuevo registro
            production_id: this.form.id, // ID de la producción principal (requerido por el backend)
            production_model_id: this.selectedGroup.id,
            inventory_id: inventoryId,
            quantity: 1, // Cambiar a 1 para cumplir con la validación del backend
            price: inventoryPrice, // Precio del inventario seleccionado
            total_price: inventoryPrice * 1, // Precio total = precio * cantidad
          };
          return await this.$store.dispatch("productionDetails/save", purchaseData);
        });

        const responses = await Promise.all(promises);
        
        // Verificar si todas las respuestas fueron exitosas
        const allSuccess = responses.every(response => 
          response && response.status >= 200 && response.status < 300
        );

        if (allSuccess) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'Los insumos han sido asignados correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then(() => {
            this.getInsumos();
            this.closeModalInsumoProduccion();
          });
        } else {
          throw new Error('Error al asignar algunos insumos');
        }

      } catch (error) {
        Swal.close();
        console.error("Error al asignar insumos:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al asignar los insumos',
        });
      }
    },
    async submitEditForm() {
      try {
        const response = await this.$store.dispatch("productionDetails/save", this.purchase);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then(() => {
            this.getInsumos();
            this.closeEditModal();
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
      } catch (error) {
        Swal.close();
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async onBodegaChange(data) {

      await this.$store.dispatch('productionModels/save', data);

      await Swal.fire({
        icon: 'success',
        title: '¡Éxito!',
        text: 'Bodega asignada',
        confirmButtonText: 'Aceptar',
        backdrop: true,
      });

    },
    async onOficioChange(data) {
      try {
        // Guardar el oficio asignado
        await this.$store.dispatch('productionModels/save', data);
        
        await Swal.fire({
          icon: 'success',
          title: '¡Éxito!',
          text: 'Oficio asignado correctamente',
          confirmButtonText: 'Aceptar',
          backdrop: true,
        });
      } catch (error) {
        console.error('Error al guardar oficio:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al asignar el oficio',
          confirmButtonText: 'Aceptar',
        });
      }
    },
    async updateQuantity(detail, event) {
      console.log('updateQuantity llamado', { detail, status: this.form.status, statusType: typeof this.form.status });
      
      // Permitir actualizar si la producción está en estado pendiente (status = 0) o en proceso (status = 1)
      const canUpdate = Number(this.form.status) === 0 || Number(this.form.status) === 1;
      if (!canUpdate) {
        console.log('Producción no permite actualizar cantidad, status:', this.form.status);
        return;
      }
      
      console.log('Producción permite actualizar cantidad, procediendo con actualización...');

      const inputElement = event.target;
      const inputValue = inputElement.value.trim();
      const newQuantity = parseFloat(inputValue);
      const originalQuantity = parseFloat(detail.quantity || 0);

      console.log('Valores:', { inputValue, newQuantity, originalQuantity });

      // Validar que la cantidad sea válida
      if (!inputValue || isNaN(newQuantity) || newQuantity <= 0) {
        // Restaurar el valor original si es inválido
        inputElement.value = originalQuantity.toString();
        await Swal.fire({
          icon: 'warning',
          title: 'Advertencia',
          text: 'Debe ingresar una cantidad válida mayor a 0',
          confirmButtonText: 'Aceptar',
        });
        return;
      }

      // Si la cantidad no cambió, no hacer nada
      if (newQuantity === originalQuantity) {
        console.log('La cantidad no cambió, no se actualiza');
        return;
      }

      try {
        console.log('Iniciando actualización de cantidad...');
        
        // Calcular el nuevo total_price basado en la nueva cantidad
        const newTotalPrice = newQuantity * parseFloat(detail.price || 0);
        
        const updateData = {
          id: detail.id,
          production_model_id: detail.production_model_id,
          inventory_id: detail.inventory_id,
          quantity: newQuantity,
          price: detail.price,
          total_price: newTotalPrice,
          discounted: detail.discounted ? 1 : 0,
          user_id: detail.user_id || null
        };
        
        console.log('Datos a actualizar:', updateData);
        
        const response = await this.$store.dispatch('productionDetails/save', updateData);
        
        console.log('Respuesta del servidor:', response);
        
        // Verificar si la respuesta es un error
        if (response && response.status && response.status >= 400) {
          const errorMessage = response.data?.message || response.data?.error || 'Error al actualizar la cantidad';
          // Restaurar el valor original en caso de error
          inputElement.value = originalQuantity.toString();
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: errorMessage,
            confirmButtonText: 'Aceptar',
          });
          return;
        }
        
        // También verificar si response es null o undefined (error en la petición)
        if (!response || !response.data) {
          console.error('Respuesta inválida:', response);
          // Restaurar el valor original en caso de error
          inputElement.value = originalQuantity.toString();
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Error al actualizar la cantidad',
            confirmButtonText: 'Aceptar',
          });
          return;
        }
        
        console.log('Actualización exitosa, actualizando datos locales...');
        
        // Actualizar el valor local inmediatamente para reflejar el cambio en la vista
        // Usar Object.assign para actualizar de forma atómica y evitar warnings del linter
        Object.assign(detail, {
          quantity: newQuantity,
          total_price: newTotalPrice
        });
        
        // Actualizar el input para reflejar el nuevo valor
        inputElement.value = newQuantity.toString();
        
        // Los computed (insumosUtilizadosAgrupados, totalInsumosUtilizados) 
        // se recalcularán automáticamente cuando Vue detecte el cambio en detail
        
        // Recargar datos para asegurar sincronización completa con el backend
        await this.getInsumos();
        
        console.log('Datos actualizados exitosamente');
        
      } catch (error) {
        console.error('Error al actualizar cantidad:', error);
        const errorMessage = error.response?.data?.message || error.message || 'Error al actualizar la cantidad';
        // Restaurar el valor original en caso de error
        inputElement.value = originalQuantity.toString();
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: errorMessage,
          confirmButtonText: 'Aceptar',
        });
      }
    },
    async updateInsumoTotalQuantity(insumo, event) {
      const canUpdate = Number(this.form.status) === 0 || Number(this.form.status) === 1;
      if (!canUpdate) return;

      const inputElement = event.target;
      const inputValue = inputElement.value.trim();
      const newTotalQuantity = parseFloat(inputValue);
      const originalTotalQuantity = parseFloat(insumo.quantity || 0);

      if (!inputValue || isNaN(newTotalQuantity) || newTotalQuantity <= 0) {
        inputElement.value = originalTotalQuantity.toFixed(2);
        await Swal.fire({
          icon: 'warning',
          title: 'Advertencia',
          text: 'Debe ingresar una cantidad válida mayor a 0',
          confirmButtonText: 'Aceptar',
        });
        return;
      }

      if (newTotalQuantity === originalTotalQuantity) return;

      // Recolectar todos los detalles que usan este insumo (inventory_id)
      const details = [];
      this.insumos.forEach(group => {
        if (group.details && Array.isArray(group.details)) {
          group.details.forEach(detail => {
            if (detail.inventory_id === insumo.inventory_id) {
              details.push(detail);
            }
          });
        }
      });

      if (details.length === 0) return;

      try {
        // Distribuir la nueva cantidad total proporcionalmente entre los detalles
        const factor = newTotalQuantity / originalTotalQuantity;

        // Actualizar cada detalle
        for (const detail of details) {
          const newQuantity = parseFloat(detail.quantity) * factor;
          const newTotalPrice = newQuantity * parseFloat(detail.price || 0);

          const updateData = {
            id: detail.id,
            production_model_id: detail.production_model_id,
            inventory_id: detail.inventory_id,
            quantity: parseFloat(newQuantity.toFixed(4)),
            price: detail.price,
            total_price: parseFloat(newTotalPrice.toFixed(4)),
            discounted: detail.discounted ? 1 : 0,
            user_id: detail.user_id || null,
          };

          const response = await this.$store.dispatch('productionDetails/save', updateData);
          if (response && response.status && response.status >= 400) {
            const errorMessage = response.data?.message || response.data?.error || 'Error al actualizar';
            inputElement.value = originalTotalQuantity.toFixed(2);
            await Swal.fire({
              icon: 'error',
              title: 'Error',
              text: errorMessage,
              confirmButtonText: 'Aceptar',
            });
            return;
          }
        }

        // Recargar datos para sincronizar con el backend
        await this.getInsumos();
      } catch (error) {
        console.error('Error al actualizar cantidad total del insumo:', error);
        inputElement.value = originalTotalQuantity.toFixed(2);
        const errorMessage = error.response?.data?.message || error.message || 'Error al actualizar la cantidad';
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: errorMessage,
          confirmButtonText: 'Aceptar',
        });
      }
    },
    async toggleDiscount(detail) {
      try {
        // Guardar el valor actual antes de hacer la actualización
        const currentDiscountedValue = Boolean(detail.discounted);
        const newDiscountedValue = !currentDiscountedValue;
        
        // Obtener el user_id desde el localStorage
        let user = JSON.parse(localStorage.getItem('user'));
        let userId = null;
        if (user && user.id) {
          userId = user.id;
        }
        
        const updateData = {
          id: detail.id,
          production_model_id: detail.production_model_id,
          inventory_id: detail.inventory_id,
          quantity: detail.quantity,
          price: detail.price,
          total_price: detail.total_price,
          discounted: newDiscountedValue ? 1 : 0,
          user_id: newDiscountedValue ? userId : null // Solo enviar user_id cuando se marca como descontado
        };
        
        const response = await this.$store.dispatch('productionDetails/save', updateData);
        
        // Verificar si la respuesta es un error
        if (response && response.status && response.status >= 400) {
          // El mensaje puede estar en response.data.message o response.data.error
          const errorMessage = response.data?.message || response.data?.error || 'Error al actualizar el descuento';
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: errorMessage,
            confirmButtonText: 'Aceptar',
          });
          return;
        }
        
        // También verificar si response es null o undefined (error en la petición)
        if (!response || !response.data) {
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Error al actualizar el descuento',
            confirmButtonText: 'Aceptar',
          });
          return;
        }
        
        // Recargar datos para actualizar la vista (esto actualizará todos los estados)
        await this.getInsumos();
        
        await Swal.fire({
          icon: 'success',
          title: '¡Éxito!',
          text: newDiscountedValue 
            ? 'Insumo marcado como descontado del inventario'
            : 'Insumo desmarcado como descontado',
          confirmButtonText: 'Aceptar',
          backdrop: true,
        });
      } catch (error) {
        console.error('Error al actualizar descuento:', error);
        const errorMessage = error.response?.data?.message || error.message || 'Error al actualizar el descuento';
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: errorMessage,
          confirmButtonText: 'Aceptar',
        });
      }
    },
    async markAllInsumosAsUtilized() {
      const insumos = this.insumosUtilizadosAgrupados;
      if (!insumos || insumos.length === 0) return;

      // Filtrar solo los que aún no están todos descontados
      const pendientes = insumos.filter(i => !this.isAllInsumoDiscounted(i.inventory_id));
      if (pendientes.length === 0) {
        await Swal.fire({
          icon: 'info',
          title: 'Información',
          text: 'Todos los insumos ya están marcados como utilizados.',
          confirmButtonText: 'Aceptar',
        });
        return;
      }

      const result = await Swal.fire({
        icon: 'question',
        title: '¿Marcar todos como utilizados?',
        html: `Se marcarán como utilizados <strong>${pendientes.length}</strong> insumo(s) en todos los modelos de esta producción.<br><br>¿Deseas continuar?`,
        showCancelButton: true,
        confirmButtonText: 'Sí, marcar todos',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#28a745',
        cancelButtonColor: '#6c757d',
      });

      if (!result.isConfirmed) return;

      // Mostrar loading único mientras se procesan todos los insumos
      Swal.fire({
        title: 'Procesando...',
        html: `Marcando ${pendientes.length} insumo(s) como utilizados...`,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Procesar cada insumo pendiente secuencialmente
      for (const insumo of pendientes) {
        await this.markAllInsumoAsDiscounted(insumo.inventory_id, insumo.inventory_name, true);
      }

      // Recargar datos una sola vez al finalizar
      await this.getInsumos();

      // Cerrar loading y mostrar resultado único
      await Swal.fire({
        icon: 'success',
        title: 'Listo',
        text: 'Todos los insumos fueron marcados como utilizados.',
        timer: 2000,
        showConfirmButton: false,
      });
    },
    async markAllInsumoAsDiscounted(inventoryId, inventoryName, skipConfirm = false) {
      try {
        // Verificar si todos están descontados para saber si hay que marcar o desmarcar
        const allDiscounted = this.isAllInsumoDiscounted(inventoryId);
        
        // Buscar todos los detalles con el mismo inventory_id en todos los grupos
        const detailsToUpdate = [];
        this.insumos.forEach(group => {
          if (group.details && Array.isArray(group.details)) {
            group.details.forEach(detail => {
              if (detail.inventory_id === inventoryId && detail.id) {
                const isDiscounted = detail.discounted === true || 
                                     detail.discounted === 1 || 
                                     detail.discounted === "1" || 
                                     detail.discounted === "true" ||
                                     String(detail.discounted).toLowerCase() === 'true';
                
                // Si todos están descontados, agregar los que están descontados para desmarcarlos
                // Si no todos están descontados, agregar los que NO están descontados para marcarlos
                if (allDiscounted && isDiscounted) {
                  detailsToUpdate.push(detail);
                } else if (!allDiscounted && !isDiscounted) {
                  detailsToUpdate.push(detail);
                }
              }
            });
          }
        });

        if (detailsToUpdate.length === 0) {
          if (!skipConfirm) {
            await Swal.fire({
              icon: 'info',
              title: 'Información',
              text: allDiscounted 
                ? 'Todos los insumos de este tipo están marcados como utilizados.' 
                : 'No hay insumos para marcar.',
              confirmButtonText: 'Aceptar',
            });
          }
          return;
        }

        // Mostrar Swal de confirmación según la acción (saltar si viene del "marcar todos")
        if (!skipConfirm) {
          const result = await Swal.fire({
            icon: 'question',
            title: allDiscounted ? '¿Desmarcar como utilizado?' : '¿Marcar como utilizado?',
            html: allDiscounted
              ? `Se desmarcarán como utilizados todos los insumos <strong>${inventoryName}</strong> en todos los modelos de esta producción.<br><br>¿Deseas continuar?`
              : `Se marcarán como utilizados todos los insumos <strong>${inventoryName}</strong> en todos los modelos de esta producción.<br><br>¿Deseas continuar?`,
            showCancelButton: true,
            confirmButtonText: allDiscounted ? 'Sí, desmarcar todos' : 'Sí, marcar todos',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: allDiscounted ? '#dc3545' : '#28a745',
            cancelButtonColor: '#6c757d',
          });

          if (!result.isConfirmed) {
            return;
          }
        }

        // Mostrar loading mientras se procesan las actualizaciones (saltar si viene del "marcar todos")
        if (!skipConfirm) {
          Swal.fire({
            title: 'Procesando...',
            html: allDiscounted
              ? `Desmarcando ${detailsToUpdate.length} insumo(s) como utilizados...`
              : `Marcando ${detailsToUpdate.length} insumo(s) como utilizados...`,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
        }

        // Obtener el user_id desde el localStorage (solo si se está marcando, no desmarcando)
        let user = JSON.parse(localStorage.getItem('user'));
        let userId = null;
        if (!allDiscounted && user && user.id) {
          userId = user.id;
        }

        // Actualizar todos los detalles encontrados
        let successCount = 0;
        let errorCount = 0;

        for (const detail of detailsToUpdate) {
          try {
            const updateData = {
              id: detail.id,
              production_model_id: detail.production_model_id,
              inventory_id: detail.inventory_id,
              quantity: detail.quantity,
              price: detail.price,
              total_price: detail.total_price,
              discounted: allDiscounted ? 0 : 1, // Si todos están descontados, desmarcar (0), sino marcar (1)
              user_id: allDiscounted ? null : userId, // Si se desmarca, user_id es null
            };

            const response = await this.$store.dispatch('productionDetails/save', updateData);

            if (response && response.status && response.status >= 400) {
              errorCount++;
            } else if (response && response.data) {
              successCount++;
            } else {
              errorCount++;
            }
          } catch (error) {
            console.error('Error al actualizar detalle:', error);
            errorCount++;
          }
        }

        // Recargar datos para actualizar la vista (saltar si viene del "marcar todos",
        // se recargará una sola vez al finalizar todos)
        if (!skipConfirm) {
          await this.getInsumos();
          Swal.close();
        }

        if (errorCount === 0) {
          if (!skipConfirm) {
            await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              html: allDiscounted
                ? `Se desmarcaron <strong>${successCount}</strong> insumo(s) como utilizados en todos los modelos.`
                : `Se marcaron <strong>${successCount}</strong> insumo(s) como utilizados en todos los modelos.`,
              confirmButtonText: 'Aceptar',
              backdrop: true,
            });
          }
        } else {
          await Swal.fire({
            icon: 'warning',
            title: 'Proceso completado con errores',
            html: allDiscounted
              ? `Se desmarcaron <strong>${successCount}</strong> insumo(s) correctamente.<br>Hubo <strong>${errorCount}</strong> error(es).`
              : `Se marcaron <strong>${successCount}</strong> insumo(s) correctamente.<br>Hubo <strong>${errorCount}</strong> error(es).`,
            confirmButtonText: 'Aceptar',
            backdrop: true,
          });
        }
      } catch (error) {
        console.error('Error al marcar insumos como utilizados:', error);
        Swal.close();
        const errorMessage = error.response?.data?.message || error.message || 'Error al marcar los insumos como utilizados';
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: errorMessage,
          confirmButtonText: 'Aceptar',
        });
      }
    },
    async handleStatusChange() {
      if (this.form.status === '1') {
        const result = await Swal.fire({
          title: 'Confirmar cambio de estado',
          text: 'Al cambiar el estado a Producción, ya no será posible agregar nuevos modelos. A partir de este momento, se habilitarán las opciones necesarias para asignar operarios y dar inicio a la ejecución de las tareas correspondientes.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, confirmar',
          cancelButtonText: 'Cancelar',
        });

        if (result.isConfirmed) {
          this.handleStatusChangeSave();
          this.getInsumos();
        } else {
          this.form.status = 0;
        }
      } else {
        this.handleStatusChangeSave();
      }

    },
    async handleStatusChangeSave() {
      const response = await this.$store.dispatch("production/save", this.form);
      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire({
          icon: 'success',
          title: '¡Éxito!',
          text: 'El estado cambio correctamente',
          confirmButtonText: 'Aceptar',
          backdrop: true,
        });
      } else {
        await Swal.fire({
          icon: 'error',
          title: '¡Insumos insufiecientes!',
          text: 'Verifica la cantidad y stock disponible en la tabla de insumos.',
          confirmButtonText: 'Aceptar',
          backdrop: true,
        });

        if (this.form.status === '1') {
          this.form.status = 0;
        }


      }
    },
    async handleOficioChange() {
      if (this.form.id != 0) {
        try {
          const payload = {
            ...this.form,
            model_id: this.form.model_id ? parseInt(this.form.model_id) : null,
            oficio_id: this.form.oficio_id ? parseInt(this.form.oficio_id) : null,
            bodega_id: this.form.bodega_id ? parseInt(this.form.bodega_id) : null,
          };
          const response = await this.$store.dispatch("production/save", payload);
          if (response && response.status >= 200 && response.status < 300) {
            // Actualizar el form con la respuesta del servidor
            this.form.oficio_id = response.data.oficio_id ? parseInt(response.data.oficio_id) : null;
          }
        } catch (error) {
          console.error("Error al guardar oficio:", error);
        }
      }
    },
    async handleBodegaChange() {
      if (this.form.id != 0) {
        try {
          const payload = {
            ...this.form,
            model_id: this.form.model_id ? parseInt(this.form.model_id) : null,
            oficio_id: this.form.oficio_id ? parseInt(this.form.oficio_id) : null,
            bodega_id: this.form.bodega_id ? parseInt(this.form.bodega_id) : null,
          };
          const response = await this.$store.dispatch("production/save", payload);
          if (response && response.status >= 200 && response.status < 300) {
            // Actualizar el form con la respuesta del servidor
            this.form.bodega_id = response.data.bodega_id ? parseInt(response.data.bodega_id) : null;
          }
        } catch (error) {
          console.error("Error al guardar bodega:", error);
        }
      }
    },
    async handleEtapaChange() {
      if (this.form.id != 0) {
        try {
          const payload = {
            ...this.form,
            model_id: this.form.model_id ? parseInt(this.form.model_id) : null,
            oficio_id: this.form.oficio_id ? parseInt(this.form.oficio_id) : null,
            bodega_id: this.form.bodega_id ? parseInt(this.form.bodega_id) : null,
          };
          const response = await this.$store.dispatch("production/save", payload);
          if (response && response.status >= 200 && response.status < 300) {
            this.form.etapa = response.data.etapa || '';
          }
        } catch (error) {
          console.error("Error al guardar etapa:", error);
        }
      }
    },
    async getBodegas() {
      this.bodegas = await this.$store.dispatch('bodegas/getAll');
    },
    async getNovelties() {
      this.loadingNovelties = true;
      try {
        this.novelties = await this.$store.dispatch('productionNovelty/getData', this.form.id);
      } finally {
        this.loadingNovelties = false;
      }
    },
    async getOficios() {
      this.processes = await this.$store.dispatch('users/getOficios');
    },
    filterUsersByOficio() {
      if (this.oficio_id != 0) {
        this.filteredUsers = this.users.filter(user => {
          // Asegúrate de que processes sea un arreglo
          const processes = Array.isArray(user.processes)
            ? user.processes
            : JSON.parse(user.processes || "[]");
          return processes.map(Number).includes(Number(this.oficio_id));
        });
      } else {
        this.filteredUsers = []; // Mostrar todos los usuarios si no hay oficio seleccionado
      }
    },
    isValidDate(date) {
      if (!date) {
        return false;
      }
      const parsedDate = new Date(date);
      return !isNaN(parsedDate.getTime());
    },
    async getModels() {
      this.models = await this.$store.dispatch('models/getAll');
      // Actualizar Select2 después de cargar los modelos
      this.$nextTick(() => {
        if (this.$refs.modelSelect) {
          // Si Select2 ya está inicializado, solo actualizar el valor
          if ($(this.$refs.modelSelect).hasClass('select2-hidden-accessible')) {
            if (this.form.model_id) {
              $(this.$refs.modelSelect).val(this.form.model_id).trigger('change');
            }
          }
        }
      });
    },
    async getSizes() {
      const modelId = this.form.model_id || this.production_model.model_id;
      if (!modelId) {
        this.sizes = [];
        this.lastLoadedModelId = null;
        return;
      }
      
      // Evitar llamadas duplicadas para el mismo modelo
      if (this.isLoadingSizes || this.lastLoadedModelId === modelId) {
        return;
      }
      
      this.isLoadingSizes = true;
      try {
        // Obtener tallas y colores desde models_model
        let response = await this.$store.dispatch('modelsModel/getData', modelId);
        this.production_model.model_id = modelId;
        // response.data contiene el array de models_model
        let tallasData = response.data || [];
        
        // Eliminar duplicados basándose en la combinación de size y color_id
        const uniqueSizes = [];
        const seen = new Set();
        
        tallasData.forEach(item => {
          const key = `${item.size}_${item.color_id}`;
          if (!seen.has(key)) {
            seen.add(key);
            uniqueSizes.push(item);
          }
        });
        
        this.sizes = uniqueSizes;
        this.lastLoadedModelId = modelId;
        console.log('Tallas obtenidas (sin duplicados):', this.sizes);
      } finally {
        this.isLoadingSizes = false;
      }
    },
    async getUsers() {

      this.users = await this.$store.dispatch('users/getAll', 'all');
      //this.users =this.$store.state.users.users;

    },
    getIconClass(status) {
      if (status === 0) {
        return 'fa fa-circle'; // Ícono de clic
      } else if (status === 1) {
        return 'fa fa-check-circle text-success'; // Ícono de check verde
      } else if (status === 2) {
        return 'fa fa-times-circle text-danger'; // Ícono de X roja
      }
      return ''; // Devuelve una cadena vacía si no coincide con ningún estado
    },
    editRegisterNovelty(params) {
      this.novelty = params;
      this.openModalNovelty();
    },
    async deleteRegisterNovelty(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionNovelty/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getNovelties();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    openModalNovelty() {
      const modalElement = document.getElementById('ModalNovelty');
      this.modalNovelty = new Modal(modalElement); // Guarda la instancia del modal
      this.modalNovelty.show(); // Muestra el modal
    },
    closeModalNovelty() {
      if (this.modalNovelty) {
        this.modalNovelty.hide(); // Cierra el modal
      }
    },
    async submitFormNovelty() {
      try {
        this.novelty.production_id = this.form.id;
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("productionNovelty/save", this.novelty);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {

              this.novelty.total = 0;
              this.novelty.observation = '';

              this.closeModalNovelty();
              this.getNovelties();

            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }

    },
    openModal() {
      this.production_user.assigned_at = new Date().toISOString().slice(0, 10);
      this.fieldPayment = true;
      const modalElement = document.getElementById('ModalBudget');
      this.modalBudget = new Modal(modalElement); // Guarda la instancia del modal
      this.modalBudget.show(); // Muestra el modal
    },
    async openModalEditQuantities() {
      await this.getData();
      this.modalQtyUserSearch = '';
      this.modalQtyModelFilter = '';
      this.modalQtyOficioFilter = '';
      this.modalDeliveredSnapshot = {};
      (this.data?.data || []).forEach((r) => {
        this.modalDeliveredSnapshot[r.id] = parseInt(r.delivered_quantity, 10) || 0;
      });
      const modalElement = document.getElementById('ModalEditQuantities');
      this.modalEditQuantities = new Modal(modalElement);
      this.modalEditQuantities.show();
    },
    closeModalEditQuantities() {
      if (this.modalEditQuantities) {
        this.modalEditQuantities.hide();
      }
    },
    blurQtyInput(ev) {
      if (ev?.target && typeof ev.target.blur === 'function') {
        ev.target.blur();
      }
    },

    normalizeDeliveredQtyFromInput(ev, fallbackRowQty) {
      let raw = '';
      if (
        ev != null &&
        typeof ev.target === 'object' &&
        Object.prototype.hasOwnProperty.call(ev.target, 'value')
      ) {
        raw = ev.target.value;
      }
      const trimmed = raw === null || raw === undefined ? '' : String(raw).trim();
      if (trimmed === '') {
        const fb = parseInt(String(fallbackRowQty), 10);
        return Number.isNaN(fb) ? 0 : fb;
      }

      let qty = parseInt(trimmed, 10);
      if (Number.isNaN(qty)) {
        qty = parseInt(String(fallbackRowQty), 10);
      }
      if (Number.isNaN(qty)) {
        qty = 0;
      }
      return qty;
    },

    async persistDeliveredQuantity(row, ev) {
      if (this.savingDeliveredRowId === row.id) {
        return;
      }

      const rowSync = Array.isArray(this.data?.data)
        ? this.data.data.find((r) => String(r.id) === String(row.id))
        : null;
      const targetRow = rowSync || row;

      const snapKey = String(row.id);
      const prevSaved = this.modalDeliveredSnapshot[row.id];
      const prevNormalized =
        prevSaved !== undefined && prevSaved !== null ? Number(prevSaved) : undefined;

      const hasEvValue =
        ev != null &&
        typeof ev.target === 'object' &&
        Object.prototype.hasOwnProperty.call(ev.target, 'value');
      const trimmedEv = hasEvValue ? String(ev.target.value).trim() : '';

      // Vacío en blur: no enviar 0 al API (valor vacío típico con type=number antes de sincronizar el modelo)
      if (hasEvValue && trimmedEv === '') {
        const restore =
          prevNormalized !== undefined && !Number.isNaN(prevNormalized)
            ? prevNormalized
            : (parseInt(String(targetRow.delivered_quantity), 10) ||
               parseInt(String(row.delivered_quantity), 10) ||
               0);
        targetRow.delivered_quantity = restore;
        ev.target.value = String(restore);
        return;
      }

      let qty = this.normalizeDeliveredQtyFromInput(ev, row.delivered_quantity);
      qty = Math.max(0, qty);

      targetRow.delivered_quantity = qty;
      if (ev?.target && typeof ev.target === 'object' && Object.prototype.hasOwnProperty.call(ev.target, 'value')) {
        ev.target.value = qty === null || qty === undefined ? '' : String(qty);
      }

      if (prevNormalized !== undefined && qty === prevNormalized) {
        return;
      }

      this.savingDeliveredRowId = row.id;
      try {
        const response = await productionUsersService.updateDeliveredQuantity(row.id, {
          delivered_quantity: qty,
        });
        if (response.status >= 200 && response.status < 300) {
          this.modalDeliveredSnapshot[row.id] = qty;
          const updated = response.data;
          const idx = this.data?.data?.findIndex((r) => String(r.id) === snapKey);
          if (idx >= 0 && updated && typeof updated === 'object') {
            this.data.data[idx] = { ...this.data.data[idx], ...updated };
            const dq = Number(this.data.data[idx].delivered_quantity);
            this.data.data[idx].delivered_quantity = Number.isNaN(dq) ? qty : dq;
          } else if (idx >= 0) {
            this.data.data[idx].delivered_quantity = qty;
          }
        }
      } catch (error) {
        const msg = error.response?.data?.message || error.message || 'No se pudo guardar la cantidad entregada.';
        const revertTo =
          prevNormalized !== undefined && !Number.isNaN(prevNormalized) ? prevNormalized : 0;

        const synced = Array.isArray(this.data?.data)
          ? this.data.data.find((r) => String(r.id) === snapKey)
          : null;

        if (synced) {
          synced.delivered_quantity = revertTo;
        }

        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: msg,
        });

        await this.getData();

        (this.data?.data || []).forEach((r) => {
          this.modalDeliveredSnapshot[r.id] = parseInt(String(r.delivered_quantity), 10) || 0;
        });
      } finally {
        this.savingDeliveredRowId = null;
      }
    },
    closeModal() {
      if (this.modalBudget) {
        this.modalBudget.hide(); // Cierra el modal
      }
      this.markAsReceived = false;
    },
    async openModalModel() {
      this.editingProductionModelId = null;
      if (!this.form.model_id) {
        await Swal.fire({
          icon: 'warning',
          title: 'Selecciona un modelo',
          text: 'Debes elegir un modelo en el formulario principal antes de asignar tallas.',
          confirmButtonText: 'Entendido',
        });
        return;
      }
      this.production_model.model_id = this.form.model_id;
      await this.getSizes();
      
      const modalElement = document.getElementById('ModalModel');
      this.modalModel = new Modal(modalElement); // Guarda la instancia del modal
      this.modalModel.show(); // Muestra el modal
      
      // Reinicializar Select2 después de cargar los datos
      this.$nextTick(() => {
        if (this.$refs.sizesSelect) {
          // Destruir Select2 si ya existe
          if ($(this.$refs.sizesSelect).hasClass('select2-hidden-accessible')) {
            $(this.$refs.sizesSelect).select2('destroy');
          }
          
          // Inicializar Select2 con los nuevos datos (múltiple)
          $(this.$refs.sizesSelect).select2({
            placeholder: 'Seleccione una o más tallas y colores',
            allowClear: true,
            multiple: true,
            dropdownParent: $('#ModalModel .modal-body'),
            width: '100%'
          }).on('change', () => {
            // Los size_id ahora son un array de IDs de models_model (múltiple)
            // El precio del costo unitario viene del modelo (form.price), no del models_model
            // Se mantiene el precio del modelo para el costo unitario
          });
        }
      });
    },
    closeModalModel() {
      this.editingProductionModelId = null;
      if (this.modalModel) {
        this.modalModel.hide(); // Cierra el modal
      }
    },
    async duplicateProductionModel(group) {
      if (!group?.id) {
        return;
      }
      try {
        const result = await Swal.fire({
          title: '¿Duplicar modelo?',
          text: 'Se creará una copia con los mismos insumos y cantidades. Cantidad enviada en remisiones quedará en cero.',
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#6c757d',
          confirmButtonText: 'Duplicar',
          cancelButtonText: 'Cancelar',
        });

        if (!result.isConfirmed) {
          return;
        }

        const response = await this.$store.dispatch('productionModels/duplicate', group.id);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: 'Modelo duplicado',
            text: 'Se agregó el registro copiado a la lista.',
            confirmButtonText: 'Aceptar',
          });
          await this.getInsumos();
        } else {
          throw new Error(response?.data?.message || 'No se pudo duplicar el modelo');
        }
      } catch (error) {
        console.error('Error al duplicar modelo:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || error?.message || 'Error al duplicar el modelo',
        });
      }
    },
    async openModalEditModel(group) {
      this.editingProductionModelId = group.id;
      this.production_model.quantity_to_produce = group.quantity_to_produce;
      this.production_model.model_id = group.model_id;
      this.production_model.production_id = this.form.id;
      this.production_model.price = this.form.price || 0;
      if (!this.form.model_id) {
        this.form.model_id = group.model_id;
      }
      await this.getSizes();
      const modalElement = document.getElementById('ModalModel');
      this.modalModel = new Modal(modalElement);
      this.modalModel.show();
      this.$nextTick(() => {
        if (this.$refs.sizesSelect) {
          if ($(this.$refs.sizesSelect).hasClass('select2-hidden-accessible')) {
            $(this.$refs.sizesSelect).select2('destroy');
          }
          $(this.$refs.sizesSelect).select2({
            placeholder: 'Seleccione una o más tallas y colores',
            allowClear: true,
            multiple: true,
            dropdownParent: $('#ModalModel .modal-body'),
            width: '100%'
          }).on('change', () => {});
          this.$nextTick(() => {
            const sizeId = group.size_id || group.size?.id;
            if (sizeId) {
              $(this.$refs.sizesSelect).val([String(sizeId)]).trigger('change');
              this.oficio_id = [sizeId];
            }
          });
        }
      });
    },
    openModalDefects() {
      const modalElement = document.getElementById('ModalDefects');
      this.modalDefects = new Modal(modalElement); // Guarda la instancia del modal
      this.modalDefects.show(); // Muestra el modal
    },
    closeModalDefects() {
      if (this.modalDefects) {
        this.modalDefects.hide(); // Cierra el modal
      }
    },
    async getData() {
      this.loadingUsers = true;
      try {
        await this.$store.dispatch('productionUsers/getData', this.form.id);
        this.data = this.$store.state.productionUsers.getData;
      } finally {
        this.loadingUsers = false;
      }
    },
    async getInsumos() {
      this.loadingInsumos = true;
      try {
        const data = await this.$store.dispatch('productionModels/getData', this.form.id);
        this.insumos = data.data;
      } finally {
        this.loadingInsumos = false;
      }
    },
    async getAllInsumos() {
      this.insumosInventory = await this.$store.dispatch('inventory/getAll');
    },
    async save() {
      // Evitar doble guardado
      if (this.isSaving) {
        return;
      }

      try {
        // Activar estado de guardado
        this.isSaving = true;

        // Mostrar modal de carga
        Swal.fire({
          title: 'Guardando...',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        const payload = {
          ...this.form,
          model_id: this.form.model_id ? parseInt(this.form.model_id) : null,
          oficio_id: this.form.oficio_id ? parseInt(this.form.oficio_id) : null,
          bodega_id: this.form.bodega_id ? parseInt(this.form.bodega_id) : null,
        };

        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("production/save", payload);
        
        // Cerrar modal de carga
        Swal.close();

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El proyecto ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {

              this.form = {
                ...response.data,
                model_id: response.data.model_id ?? null,
                selling_cost: response.data.selling_cost || 0,
                wholesale_price: response.data.wholesale_price || 0,
                retail_price: response.data.retail_price || 0,
                oficio_id: response.data.oficio_id ? parseInt(response.data.oficio_id) : null,
                bodega_id: response.data.bodega_id ? parseInt(response.data.bodega_id) : null,
              };
              this.form.id = response.data.id || 0;
              this.modal.project_id = response.data.id || 0;

              // Actualizar URL con el id de la producción
              if (response.data.id) {
                this.$router.replace({ query: { id: response.data.id } });
              }

              this.production_model.production_id = response.data.id || 0;
              this.production_model.model_id = this.form.model_id || 0;
              this.production_user.production_id = response.data.id || 0;

              this.getInsumos();
              this.getModels();
              this.getOficios();
              this.getBodegas();
              this.getSizes();
              this.getUsers();

              // Actualizar Select2 después de guardar
              this.$nextTick(() => {
                if (this.$refs.modelSelect && this.form.model_id) {
                  $(this.$refs.modelSelect).val(this.form.model_id).trigger('change');
                }
              });
            }
          });

        } else {
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        // Cerrar modal de carga en caso de error
        Swal.close();
        console.error("Error al crear el proyecto:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el proyecto',
        });
      } finally {
        // Desactivar estado de guardado
        this.isSaving = false;
      }
    },
    async submitForm() {
      if (this.isSavingUser) {
        return;
      }

      try {
        this.isSavingUser = true;
        this.production_user.oficio_id = this.oficio_id;
        if (this.markAsReceived) {
          this.production_user.received_date = new Date().toISOString().slice(0, 10);
        } else {
          this.production_user.received_date = null;
        }
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("productionUsers/save", this.production_user);

        if (response && response.status >= 200 && response.status < 300) {
          const successMessage = response?.data?.message || 'El registro ha sido guardado correctamente.';

          const escapeHtml = (value) => String(value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');

          const lines = String(successMessage)
            .split('\n')
            .map(line => line.trim())
            .filter(Boolean);

          let successHtml = '';
          const firstBulletIndex = lines.findIndex(line => line.startsWith('- '));

          if (firstBulletIndex >= 0) {
            const headerLines = lines.slice(0, firstBulletIndex);
            const bulletLines = lines.slice(firstBulletIndex).filter(line => line.startsWith('- '));

            successHtml = headerLines.map(line => `<div>${escapeHtml(line)}</div>`).join('');
            successHtml += `
              <ul style="text-align: left; margin: 8px 0 0 0; padding-left: 20px; list-style-type: disc; list-style-position: outside;">
                ${bulletLines.map(line => `<li>${escapeHtml(line.replace(/^-\\s*/, ''))}</li>`).join('')}
              </ul>
            `;
          } else {
            successHtml = lines.map(line => `<div>${escapeHtml(line)}</div>`).join('');
          }

          successHtml = `<div style="text-align: left;">${successHtml}</div>`;

          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            html: successHtml,
            confirmButtonText: 'Aceptar',
            backdrop: true,
          });

          // Descarga automática del PDF al asignar usuario (deshabilitada)
          // if (productionUserId) {
          //   try {
          //     const pdfResponse = await this.$store.dispatch("productionUsers/getPdf", productionUserId);
          //
          //     const url = window.URL.createObjectURL(new Blob([pdfResponse.data]));
          //
          //     const link = document.createElement("a");
          //     link.href = url;
          //     link.setAttribute("download", `formato_entrega_corte_${productionUserId}.pdf`);
          //     document.body.appendChild(link);
          //     link.click();
          //
          //     document.body.removeChild(link);
          //     window.URL.revokeObjectURL(url);
          //   } catch (error) {
          //     console.error("Error al generar el PDF:", error);
          //   }
          // }

          this.getData();
          this.getInsumos();
          this.closeModal();

          this.production_user.production_models_id = 0;
          this.production_user.oficio_id = 0;
          this.production_user.user_id = 0;
          this.production_user.received_quantity = 0;
          this.production_user.price = 0;
          this.production_user.benefit = 0;
          this.production_user.delivered_quantity = 0;
          this.production_user.received_date = null;
          this.markAsReceived = false;

          $(this.$refs.modelUserSelect).val(null).trigger('change');
          $(this.$refs.processesSelect).val(null).trigger('change');
          $(this.$refs.usersSelect).val(null).trigger('change');
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      } finally {
        this.isSavingUser = false;
      }

    },
    async submitFormModel() {
      try {
        // Modo edición: actualizar solo cantidad y precio del modelo existente
        if (this.editingProductionModelId) {
          const quantity = typeof this.production_model.quantity_to_produce === 'string'
            ? parseFloat(String(this.production_model.quantity_to_produce).replace(/\./g, '').replace(',', '.')) || 0
            : parseFloat(this.production_model.quantity_to_produce) || 0;
          if (!quantity || quantity <= 0) {
            await Swal.fire({
              icon: 'warning',
              title: 'Cantidad requerida',
              text: 'Debe ingresar una cantidad válida para producir.',
              confirmButtonText: 'Aceptar',
            });
            return;
          }
          const price = this.form.price || 0;
          const data = {
            id: this.editingProductionModelId,
            production_id: this.production_model.production_id,
            model_id: this.production_model.model_id,
            size_id: $(this.$refs.sizesSelect).val()?.[0] || null,
            quantity_to_produce: quantity,
            price: price,
            bodega_id: this.production_model.bodega_id || null,
          };
          const response = await this.$store.dispatch('productionModels/save', data);
          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El modelo se actualizó correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
            });
            this.production_model.quantity_to_produce = 0;
            this.production_model.price = 0;
            $(this.$refs.sizesSelect).val(null).trigger('change');
            this.getInsumos();
            this.closeModalModel();
          } else {
            throw new Error(response?.data?.message || 'Error al actualizar');
          }
          return;
        }

        // Obtener los IDs seleccionados del Select2 múltiple
        const selectedSizeIds = $(this.$refs.sizesSelect).val() || [];
        
        if (selectedSizeIds.length === 0) {
          await Swal.fire({
            icon: 'warning',
            title: 'Seleccione al menos una talla',
            text: 'Debe seleccionar al menos una talla y color para continuar.',
            confirmButtonText: 'Aceptar',
          });
          return;
        }

        // Validar que haya una cantidad
        if (!this.production_model.quantity_to_produce || this.production_model.quantity_to_produce <= 0) {
          await Swal.fire({
            icon: 'warning',
            title: 'Cantidad requerida',
            text: 'Debe ingresar una cantidad válida para producir.',
            confirmButtonText: 'Aceptar',
          });
          return;
        }

        // Asignar el precio del modelo al production_model antes de guardar
        const price = this.form.price || 0;
        
        // Crear un registro para cada talla seleccionada
        const promises = selectedSizeIds.map(sizeId => {
          const productionModel = {
            id: 0,
            production_id: this.production_model.production_id,
            model_id: this.production_model.model_id,
            size_id: sizeId,
            quantity_to_produce: this.production_model.quantity_to_produce,
            price: price,
            bodega_id: this.production_model.bodega_id || null,
          };
          
          return this.$store.dispatch("productionModels/save", productionModel);
        });

        // Ejecutar todas las peticiones en paralelo
        const responses = await Promise.all(promises);
        
        // Verificar que todas las respuestas sean exitosas
        const allSuccess = responses.every(response => response && response.status >= 200 && response.status < 300);
        
        if (allSuccess) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: `Se crearon ${selectedSizeIds.length} registro(s) correctamente.`,
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              // Limpiar el formulario
              this.production_model.size_id = 0;
              this.production_model.quantity_to_produce = 0;
              this.production_model.price = 0;

              // Limpiar el select2 múltiple
              $(this.$refs.sizesSelect).val(null).trigger('change');

              // Refrescar los datos
              this.getInsumos();
              this.closeModalModel();
            }
          });
        } else {
          throw new Error('Algunos registros no se pudieron guardar correctamente');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }

    },
    async deleteRegister(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionModels/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getInsumos();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    async deleteRegisterDetail(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionDetails/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getInsumos();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    viewObservation(observation) {
      // Mostramos el mensaje en un SweetAlert
      Swal.fire({
        title: 'Observación',
        text: observation || 'No hay observaciones disponibles.',
        icon: 'info',  // Puedes cambiar el icono a info, success, warning, etc.
        confirmButtonText: 'Aceptar'
      });
    },
    async checkReceived(value) {

      try {
        const result = await Swal.fire({
          title: 'Recibir Tarea',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, aceptar',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {

          value.received_date = new Date().toISOString().slice(0, 10);

          const response = await this.$store.dispatch("productionUsers/save", value);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Tarea aceptada!',
              'Recuerda realizar la entrega.',
              'success'
            );

            this.getData();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    async handleDeliveredInput(value) {
      const deliveredQty = Number(value.delivered_quantity);
      const receivedQty = Number(value.received_quantity);

      if (isNaN(deliveredQty) || deliveredQty <= 0) {
        return;
      }

      if (deliveredQty > receivedQty) {
        await Swal.fire({
          icon: 'warning',
          title: 'Cantidad excedida',
          text: 'La cantidad entregada no puede ser mayor a la recibida.',
        });
        return;
      }

      const { value: formValues } = await Swal.fire({
        title: 'Entregar Tarea',
        html: `
        <div style="text-align: left;">
          <div class="mb-3">
            <label class="form-label" style="font-weight: bold;">Cantidad entregada: ${deliveredQty}</label>
          </div>
          <div class="mb-3">
            <label for="swal-input-obs-deliver" class="form-label" style="font-weight: bold;">Observación:</label>
            <textarea id="swal-input-obs-deliver" class="form-control" placeholder="Agregue una observación" rows="3"></textarea>
          </div>
        </div>`,
        focusConfirm: false,
        preConfirm: () => {
          const obs = document.getElementById('swal-input-obs-deliver').value;
          return { obs };
        },
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'sí, aceptar',
        cancelButtonText: 'Cancelar',
      });

      if (!formValues) return;

      const updatedValue = { ...value };
      updatedValue.delivered_date = new Date().toISOString().slice(0, 10);
      updatedValue.delivered_quantity = deliveredQty;
      updatedValue.observation = formValues.obs;

      try {
        const response = await this.$store.dispatch("productionUsers/save", updatedValue);

        if (response && response.status >= 200 && response.status < 300) {
          if (deliveredQty < receivedQty) {
            const remaining = receivedQty - deliveredQty;
            await this.checkValidated(updatedValue, remaining);
          } else {
            await Swal.fire('Tarea Entregada!', 'Excelente trabajo.', 'success');
            this.getData();
          }
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
      } catch (error) {
        console.error("Error al guardar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async checkDelivered(value) {

      const updatedValue = { ...value };

      try {

        let cantt = Number(updatedValue.received_quantity) - Number(updatedValue.delivered_quantity);


        const { value: formValues } = await Swal.fire({
          title: 'Entregar Tarea',
          html: `
          <div style="text-align: left;">
          <div class="mb-3">
                <label for="swal-input-cant" class="form-label" style="font-weight: bold;">Si entregas una cantidad menor a la recibida, tendreas que volver a realizar la entrega del restante</label>
              </div>
              <div class="mb-3" hidden>
                <label for="swal-input-cant" class="form-label" style="font-weight: bold;">Cantidad entregada:</label>
                <input id="swal-input-cant" type="number" class="form-control" placeholder="Cantidad entregada" min="1" value="${cantt}">
              </div>
              <div class="mb-3">
                <label for="swal-input-obs" class="form-label" style="font-weight: bold;">Observación:</label>
                <textarea id="swal-input-obs" class="form-control" placeholder="Agregue una observación" rows="3"></textarea>
              </div>
            </div>`,
          focusConfirm: false,
          preConfirm: () => {
            const cant = document.getElementById('swal-input-cant').value;
            const obs = document.getElementById('swal-input-obs').value;


            return { cant: parseInt(cant, 10), obs };
          },
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'sí, aceptar',
          cancelButtonText: 'Cancelar',
        });

        if (formValues) {
          updatedValue.delivered_date = new Date().toISOString().slice(0, 10);
          updatedValue.delivered_quantity = formValues.cant;
          updatedValue.observation = formValues.obs;

          const response = await this.$store.dispatch("productionUsers/save", updatedValue);

          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire(
              'Tarea Entregada!',
              'Excelente trabajo.',
              'success'
            );
            this.getData();
          } else {
            throw new Error(response.data.message || 'Error al guardar el registro');
          }
        }
      } catch (error) {
        console.error("Error al guardar el registro:", error);


        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });



      }
    },
    async checkValidated(value, prefilledDefects = null) {
  try {
    // Asegurarse de que oficios esté cargado
    if (!this.processes || this.processes.length === 0) {
      await this.getOficios();
    }
    if (!this.users || this.users.length === 0) {
      await this.getUsers();
    }

    const { value: formValues } = await Swal.fire({
      title: 'Validar Tarea',
      html: `
        <div style="text-align: left;">
          <!-- Defectos -->
          <div class="mb-3">
            <label for="swal-input-defect" class="form-label" style="font-weight: bold;">Cantidad con defectos (Imperfectos):</label>
            <input id="swal-input-defect" type="number" class="form-control" placeholder="Cantidad con defectos" min="0" value="${prefilledDefects !== null ? prefilledDefects : ''}">
          </div>

          <!-- Campos para nueva tarea cuando hay imperfectos (se muestran cuando hay imperfectos) -->
          <div id="swal-nueva-tarea-section" style="display:none;">
            <div class="mb-3">
              <label for="swal-select-oficio-nueva" class="form-label" style="font-weight: bold;">Oficio para nueva tarea:</label>
              <select id="swal-select-oficio-nueva" class="form-control">
                <option value="">Seleccionar oficio</option>
                ${this.processes.map(o => `<option value="${o.id}">${o.name}</option>`).join("")}
              </select>
            </div>
            <div class="mb-3">
              <label for="swal-user-nueva" class="form-label" style="font-weight: bold;">Seleccionar usuario de tarea:</label>
              <select id="swal-user-nueva" class="form-control">
                <option value="">Seleccionar usuario</option>
                ${this.users.map(u => `<option value="${u.id}">${u.name}</option>`).join("")}
              </select>
            </div>
            <div class="mb-3">
              <label for="swal-observacion-nueva" class="form-label" style="font-weight: bold;">Observación:</label>
              <textarea id="swal-observacion-nueva" class="form-control" rows="3" placeholder="Agregar observación"></textarea>
            </div>
          </div>

        </div>
      `,
      didOpen: () => {
        const defectInput = document.getElementById('swal-input-defect');
        const nuevaTareaSection = document.getElementById('swal-nueva-tarea-section');
        const popup = Swal.getPopup();
        const oficioSelect = document.getElementById('swal-select-oficio-nueva');
        const userSelect = document.getElementById('swal-user-nueva');

        // Si viene con defectos pre-llenados (entrega parcial), mostrar sección nueva tarea
        if (prefilledDefects !== null && prefilledDefects > 0) {
          defectInput.value = String(prefilledDefects);
          defectInput.readOnly = true;
          nuevaTareaSection.style.display = 'block';
        }

        // Autoseleccionar el oficio del registro actual en "Oficio para nueva tarea"
        const currentOficioId = value?.oficio_id ?? value?.oficio?.id ?? '';
        if (oficioSelect && currentOficioId) {
          oficioSelect.value = String(currentOficioId);

          // Fallback por nombre si el ID no coincide exactamente con las opciones cargadas
          if (!oficioSelect.value && value?.oficio?.name) {
            const matchedOficio = this.processes.find(
              (item) => String(item?.name || '').trim().toLowerCase() === String(value.oficio.name).trim().toLowerCase()
            );
            if (matchedOficio?.id) {
              oficioSelect.value = String(matchedOficio.id);
            }
          }
        }

        const getUsersByOficio = (oficioId) => {
          if (!oficioId) return [];
          return this.users.filter((user) => {
            try {
              const processes = Array.isArray(user.processes)
                ? user.processes
                : JSON.parse(user.processes || '[]');
              return processes.map(Number).includes(Number(oficioId));
            } catch (error) {
              return false;
            }
          });
        };

        const renderUsersByOficio = (oficioId) => {
          if (!userSelect) return;

          const usersByOficio = getUsersByOficio(oficioId);
          userSelect.innerHTML = `
            <option value="">Seleccionar usuario</option>
            ${usersByOficio.map((u) => `<option value="${u.id}">${u.name}</option>`).join('')}
          `;

          if ($('#swal-user-nueva').hasClass('select2-hidden-accessible')) {
            $('#swal-user-nueva').off('change').select2('destroy');
          }

          $('#swal-user-nueva').select2({
            placeholder: 'Seleccionar usuario',
            allowClear: true,
            width: '100%',
            dropdownParent: $(popup),
          });
        };

        // Cargar usuarios filtrados según el oficio autoseleccionado
        renderUsersByOficio(oficioSelect?.value || '');

        // Cuando cambie el oficio, recargar usuarios permitidos
        if (oficioSelect) {
          oficioSelect.addEventListener('change', () => {
            renderUsersByOficio(oficioSelect.value || '');
          });
        }

        // Función para actualizar la visibilidad basada en imperfectos
        const updateVisibility = () => {
          const cant = Number(defectInput.value) || 0;
          
          if (cant > 0) {
            // Si hay imperfectos, mostrar campos de nueva tarea
            nuevaTareaSection.style.display = 'block';
          } else {
            // Si no hay imperfectos, ocultar campos de nueva tarea
            nuevaTareaSection.style.display = 'none';
          }
        };

        // Actualizar visibilidad cuando cambia la cantidad de imperfectos
        defectInput.addEventListener('input', updateVisibility);
      },
      focusConfirm: false,
      preConfirm: () => {
        const defectInput = document.getElementById('swal-input-defect').value;

        if (defectInput === '' || isNaN(defectInput)) {
          Swal.showValidationMessage('Debe ingresar una cantidad válida de defectos.');
          return false;
        }
        const cant = Number(defectInput);
        if (cant > Number(value.received_quantity)) {
          Swal.showValidationMessage('La cantidad con defectos supera la asignada.');
          return false;
        }

        // Si hay imperfectos, validar y retornar datos de nueva tarea
        if (cant > 0) {
          const oficioNueva = document.getElementById('swal-select-oficio-nueva')?.value || '';
          const userNueva = document.getElementById('swal-user-nueva')?.value || '';
          const obsNueva = document.getElementById('swal-observacion-nueva')?.value || '';

          if (!oficioNueva) {
            Swal.showValidationMessage('Debe seleccionar un oficio para la nueva tarea.');
            return false;
          }
          if (!userNueva) {
            Swal.showValidationMessage('Debe seleccionar un usuario para la nueva tarea.');
            return false;
          }

          // Usar la cantidad de defectos como cantidad para la nueva tarea
          return {
            defectos: cant,
            selected_option: 'new_task',
            nueva_tarea: {
              oficio_id: parseInt(oficioNueva),
              user_id: parseInt(userNueva),
              cantidad: cant, // Usar la cantidad de defectos
              observacion: obsNueva.trim()
            },
            oficio_id: parseInt(oficioNueva)
          };
        }

        // Si no hay imperfectos, solo retornar defectos
        return {
          defectos: cant,
          selected_option: null
        };
      },
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
    });

    if (formValues) {
      // CREAR NUEVA TAREA ANTES DE VALIDAR LA TAREA ACTUAL
      console.log('formValues:', formValues);
      console.log('formValues.nueva_tarea:', formValues.nueva_tarea);
      console.log('formValues.oficio_id:', formValues.oficio_id);
      
      // Manejar nueva tarea cuando hay imperfectos
      if (formValues.selected_option === 'new_task' && formValues.nueva_tarea) {
        try {
          // Fecha de asignación: fecha actual del día
          const today = new Date().toISOString().slice(0, 10);
          
          const newTask = {
            id: 0,
            production_id: value.production_id,
            production_models_id: value.production_models_id,
            oficio_id: formValues.nueva_tarea.oficio_id,
            user_id: formValues.nueva_tarea.user_id,
            received_quantity: formValues.nueva_tarea.cantidad,
            observation: formValues.nueva_tarea.observacion || `Tarea creada automáticamente desde defectuosos de tarea #${value.id}`,
            status: 0,
            assigned_at: today,
            check_defects: true,
          };
          
          console.log('Creando nueva tarea ANTES de validar:', newTask);
          const newTaskResponse = await this.$store.dispatch("productionUsers/save", newTask);
          console.log('Respuesta creación nueva tarea:', newTaskResponse);
          
          if (newTaskResponse && newTaskResponse.status >= 200 && newTaskResponse.status < 300) {
            console.log('Nueva tarea creada exitosamente');
          } else {
            console.error('Error al crear nueva tarea - respuesta:', newTaskResponse);
            throw new Error('Error al crear la nueva tarea');
          }
        } catch (error) {
          console.error("Error al crear nueva tarea:", error);
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Error al crear la nueva tarea: ' + (error.message || 'Error desconocido') + '. La tarea no se validará.',
          });
          return; // No continuar con la validación si falla la creación de la nueva tarea
        }
      }

      // AHORA SÍ VALIDAR LA TAREA ACTUAL
      // Crear un nuevo objeto para evitar race conditions
      const updatedValue = {
        ...value,
        validated_date: new Date().toISOString().slice(0, 10),
        rejected_quantity: formValues.defectos,
        finish: 1,
        selected_option: formValues.selected_option, // 🔹 Ya viene en inglés
      };

      if (formValues.corte) {
        Object.assign(updatedValue, {
          corte_user_id: formValues.corte.user_id,
          corte_cantidad: formValues.corte.cantidad,
          laundry_observation: formValues.corte.observacion
        });
      }

      if (formValues.lavanderia) {
        Object.assign(updatedValue, {
          laundry_observation: formValues.lavanderia.observacion
        });
      }

      if (formValues.arreglos) {
        Object.assign(updatedValue, {
          arreglo_user_id: formValues.arreglos.user_id,
          arreglo_cantidad: formValues.arreglos.cantidad,
          laundry_observation: formValues.arreglos.observacion,
        });
      }

      const response = await this.$store.dispatch("productionUsers/save", updatedValue);
      if (response && response.status >= 200 && response.status < 300) {

        // Mensaje de éxito
        let successMessage = 'Excelente trabajo.';
        if (formValues.corte || formValues.arreglos) {
          if (formValues.oficio_id) {
            successMessage = 'Tarea validada y nueva tarea creada.';
          } else {
            successMessage = 'Tarea validada.';
          }
        } else if (formValues.lavanderia) {
          successMessage = 'Tarea validada. Observación de lavandería guardada.';
        }

        await Swal.fire('Tarea Validada!', successMessage, 'success');
        await this.getData();
        this.getInsumos();
      } else {
        throw new Error(response.data.message || 'Error al guardar el registro');
      }
    }
  } catch (error) {
    console.error("Error al validar el registro:", error);
    await Swal.fire({
      icon: 'error',
      title: 'Error',
      text: error.message || 'Error al validar el registro',
    });
  }
},
    async handleSellingCostBlur() {
      try {
        // Remover puntos de mil y convertir a número
        const numericValue = parseFloat(this.formattedSellingCost.replace(/\./g, "")) || 0;
        this.form.selling_cost = numericValue;
        this.form.wholesale_price = parseFloat(this.formattedWholesalePrice.replace(/\./g, "")) || 0;
        this.form.retail_price = parseFloat(this.formattedRetailPrice.replace(/\./g, "")) || 0;
        
        // Solo guardar si hay un ID (registro existente)
        if (this.form.id && this.form.id !== 0) {
          const response = await this.$store.dispatch("production/save", this.form);
          
          if (response && response.status >= 200 && response.status < 300) {
            // Actualizar el formulario con la respuesta
            this.form = {
              ...this.form,
              ...response.data,
              selling_cost: response.data.selling_cost || 0,
              wholesale_price: response.data.wholesale_price || 0,
              retail_price: response.data.retail_price || 0,
              oficio_id: response.data.oficio_id ? parseInt(response.data.oficio_id) : null,
              bodega_id: response.data.bodega_id ? parseInt(response.data.bodega_id) : null,
            };
          }
        }
      } catch (error) {
        console.error('Error al guardar precio de venta:', error);
      }
    },
    async handleReceivedQuantityChange(value) {
      try {
        // Validar que la cantidad sea válida
        if (!value.received_quantity || value.received_quantity <= 0) {
          await Swal.fire({
            icon: 'warning',
            title: 'Cantidad inválida',
            text: 'La cantidad recibida debe ser mayor a 0.',
          });
          // Recargar datos para restaurar el valor anterior
          this.getData();
          return;
        }

        // Guardar el cambio
        const response = await this.$store.dispatch("productionUsers/save", value);
        
        if (response && response.status >= 200 && response.status < 300) {
          // Actualizar los datos localmente sin recargar toda la tabla
          const index = this.data.data.findIndex(item => item.id === value.id);
          if (index !== -1) {
            this.data.data[index] = { ...this.data.data[index], ...response.data };
          }
          
          // Mostrar mensaje de éxito
          await Swal.fire({
            icon: 'success',
            title: 'Cantidad cambiada',
            text: 'La cantidad recibida ha sido actualizada correctamente.',
            timer: 2000,
            showConfirmButton: false,
          });
        } else {
          throw new Error(response.data?.message || 'Error al actualizar la cantidad');
        }
      } catch (error) {
        console.error("Error al actualizar la cantidad recibida:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al actualizar la cantidad recibida',
        });
        // Recargar datos para restaurar el valor anterior
        this.getData();
      }
    },
    async deleteUserRegister(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionUsers/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getData();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    async generatePdf(id) {
      try {
        // Generar el PDF
        const response = await this.$store.dispatch("productionUsers/getPdf", id);
        
        // Crear una URL del archivo recibido
        const url = window.URL.createObjectURL(new Blob([response.data]));
        
        // Crear un enlace para descargar el archivo
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `formato_entrega_corte_${id}.pdf`);
        document.body.appendChild(link);
        link.click();
        
        // Limpiar la URL creada
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        await Swal.fire({
          icon: 'success',
          title: '¡Éxito!',
          text: 'El PDF se ha generado correctamente.',
          timer: 2000,
          showConfirmButton: false
        });
      } catch (error) {
        console.error("Error al generar el PDF:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'Error al generar el PDF',
        });
      }
    },
    // Métodos para selección masiva
    getItemState(item) {
      // Determinar el estado del registro: 'receive', 'deliver', 'validate', 'validated'
      if (item.validated_date != null) {
        return 'validated';
      }
      if (item.delivered_date != null && item.validated_date == null) {
        return 'validate';
      }
      if (item.received_date != null && item.delivered_date == null) {
        return 'deliver';
      }
      if (item.received_date == null) {
        return 'receive';
      }
      return null;
    },
    canSelectItem(item) {
      // Si no hay items seleccionados, permitir seleccionar
      if (this.selectedItems.length === 0) {
        return true;
      }
      // Si el item ya está validado, no se puede seleccionar
      if (item.validated_date != null) {
        return false;
      }
      // Verificar que el estado del item coincida con el estado de los items seleccionados
      const itemState = this.getItemState(item);
      return itemState === this.selectedItemsState;
    },
    handleCheckboxChange(item, event) {
      const isChecked = event.target.checked;
      const itemState = this.getItemState(item);
      
      // Si el item está validado, no permitir seleccionar
      if (item.validated_date != null) {
        event.target.checked = false;
        return;
      }
      
      if (isChecked) {
        // Si es el primer item seleccionado, agregarlo
        if (this.selectedItems.length === 0) {
          this.selectedItems.push(item.id);
        } else {
          // Obtener el estado del primer item seleccionado
          const firstSelected = Array.isArray(this.data.data) 
            ? this.data.data.find(i => this.selectedItems.includes(i.id))
            : null;
          const firstSelectedState = firstSelected ? this.getItemState(firstSelected) : null;
          
          // Verificar que el estado coincida
          if (itemState === firstSelectedState) {
            this.selectedItems.push(item.id);
          } else {
            // Si no coincide, mostrar mensaje y no seleccionar
            event.target.checked = false;
            Swal.fire({
              icon: 'warning',
              title: 'Atención',
              text: 'Solo puede seleccionar registros del mismo estado. Deseleccione los actuales para seleccionar otros.',
              timer: 2000,
              showConfirmButton: false,
            });
          }
        }
      } else {
        // Deseleccionar
        const index = this.selectedItems.indexOf(item.id);
        if (index > -1) {
          this.selectedItems.splice(index, 1);
        }
      }
    },
    toggleSelectAll() {
      if (!Array.isArray(this.data.data)) return;
      
      if (this.isAllSelected) {
        this.selectedItems = [];
      } else {
        // Solo seleccionar los items que no estén validados y que coincidan con el estado del primer item seleccionado
        if (this.selectedItems.length === 0) {
          // Si no hay nada seleccionado, seleccionar todos los que pueden recibir tarea
          this.selectedItems = this.data.data
            .filter(item => item.validated_date == null && item.received_date == null)
            .map(item => item.id);
        } else {
          // Si ya hay algo seleccionado, seleccionar todos los del mismo estado
          const state = this.selectedItemsState;
          if (state) {
            this.selectedItems = this.data.data
              .filter(item => this.getItemState(item) === state)
              .map(item => item.id);
          }
        }
      }
    },
    clearSelection() {
      this.selectedItems = [];
    },
    async bulkMarkAsReceived() {
      if (!Array.isArray(this.data.data) || this.selectedItems.length === 0) {
        await Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Debe seleccionar al menos un registro.',
        });
        return;
      }

      // Filtrar solo los que pueden ser marcados como recibidos
      const validIds = this.data.data
        .filter(item => this.selectedItems.includes(item.id) && item.received_date == null)
        .map(item => item.id);

      if (validIds.length === 0) {
        await Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Los registros seleccionados ya están marcados como recibidos o no pueden ser marcados.',
        });
        return;
      }

      try {
        const result = await Swal.fire({
          title: 'Marcar como Recibido',
          text: `¿Está seguro de marcar ${validIds.length} registro(s) como recibido(s)?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, marcar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          // Marcar cada registro como recibido
          const promises = validIds.map(id => {
            const item = this.data.data.find(i => i.id === id);
            if (item) {
              item.received_date = new Date().toISOString().slice(0, 10);
              return this.$store.dispatch("productionUsers/save", item);
            }
            return Promise.resolve();
          });

          await Promise.all(promises);
          
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: `${validIds.length} registro(s) marcado(s) como recibido(s) correctamente.`,
          });
          this.clearSelection();
          this.getData();
        }
      } catch (error) {
        console.error("Error al marcar como recibido:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al marcar los registros como recibidos',
        });
      }
    },
    async bulkMarkAsDelivered() {
      if (!Array.isArray(this.data.data) || this.selectedItems.length === 0) {
        await Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Debe seleccionar al menos un registro.',
        });
        return;
      }

      // Filtrar solo los que pueden ser marcados como entregados
      const validIds = this.data.data
        .filter(item => this.selectedItems.includes(item.id) && item.received_date != null && item.delivered_date == null)
        .map(item => item.id);

      if (validIds.length === 0) {
        await Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Los registros seleccionados ya están marcados como entregados o no pueden ser marcados.',
        });
        return;
      }

      try {
        const result = await Swal.fire({
          title: 'Marcar como Entregado',
          text: `¿Está seguro de marcar ${validIds.length} registro(s) como entregado(s)?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, marcar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          // Marcar cada registro como entregado
          const promises = validIds.map(id => {
            const item = this.data.data.find(i => i.id === id);
            if (item) {
              // La cantidad entregada por defecto es igual a la cantidad recibida
              const updatedItem = {
                ...item,
                delivered_date: new Date().toISOString().slice(0, 10),
                delivered_quantity: Number(item.received_quantity) || 0,
                observation: item.observation || '',
              };
              return this.$store.dispatch("productionUsers/save", updatedItem);
            }
            return Promise.resolve();
          });

          await Promise.all(promises);
          
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: `${validIds.length} registro(s) marcado(s) como entregado(s) correctamente.`,
          });
          this.clearSelection();
          this.getData();
        }
      } catch (error) {
        console.error("Error al marcar como entregado:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al marcar los registros como entregados',
        });
      }
    },
    async bulkMarkAsValidated() {
      if (!Array.isArray(this.data.data) || this.selectedItems.length === 0) {
        await Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Debe seleccionar al menos un registro.',
        });
        return;
      }

      // Filtrar solo los que pueden ser marcados como validados
      const validIds = this.data.data
        .filter(item => this.selectedItems.includes(item.id) && item.delivered_date != null && item.validated_date == null)
        .map(item => item.id);

      if (validIds.length === 0) {
        await Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Los registros seleccionados ya están marcados como validados o no pueden ser marcados.',
        });
        return;
      }

      try {
        const result = await Swal.fire({
          title: 'Marcar como Validado',
          text: `¿Está seguro de marcar ${validIds.length} registro(s) como validado(s)? Se marcarán con 0 defectos.`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, marcar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          // Marcar cada registro como validado
          const promises = validIds.map(id => {
            const item = this.data.data.find(i => i.id === id);
            if (item) {
              item.validated_date = new Date().toISOString().slice(0, 10);
              item.rejected_quantity = 0;
              item.finish = 1;
              return this.$store.dispatch("productionUsers/save", item);
            }
            return Promise.resolve();
          });

          await Promise.all(promises);
          
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: `${validIds.length} registro(s) marcado(s) como validado(s) correctamente.`,
          });
          this.clearSelection();
          
          this.getData();
          this.getModels();
          this.getOficios();
          this.getBodegas()
          this.getInsumos();
          
        }
      } catch (error) {
        console.error("Error al marcar como validado:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al marcar los registros como validados',
        });
      }
    },
    async loadSettings() {
      try {
        const response = await this.$store.dispatch("settings/get");
        if (response && response.data) {
          this.benefitsOfTasks = response.data.benefits_of_tasks || false;
        }
      } catch (error) {
        console.error("Error al cargar la configuración:", error);
      }
    },

  },
  async mounted() {

    const route = useRoute();
    const dataEdit = route.params.data;
    const queryId = route.query.id;

    (async () => {
      // Mostrar el modal de "Cargando"
      Swal.fire({
        icon: 'info',
        title: 'Cargando...',
        text: 'Estamos obteniendo los datos, por favor espera.',
        didOpen: () => {
          Swal.showLoading();
        },
        confirmButtonText: 'Aceptar',
        backdrop: true,
      });

      try {
        let isEditing = false;
        let params = null;

        // Determinar si es edición: por query param ?id= o por route.params.data
        if (queryId) {
          // Cargar producción desde la API usando el id de la URL
          const response = await this.$store.dispatch('production/getData', queryId);
          if (response && response.data) {
            params = response.data;
            isEditing = true;
          }
        } else if (dataEdit) {
          params = JSON.parse(dataEdit);
          isEditing = true;
        }

        // Configurar Select2 del modal de edición de insumos
        $(this.$refs.insumosEditSelect).select2({
          placeholder: 'Seleccione un insumo',
          allowClear: false,
          dropdownParent: $('#ModalEditInsumo .modal-body')
        });
        $(this.$refs.insumosEditSelect).on('change', () => {
          this.purchase.inventory_id = $(this.$refs.insumosEditSelect).val();
        });

        // === FASE 1: Cargar datos del card principal "Crear Produccion de Modelo" ===
        if (isEditing && params && params.id) {
          this.data = params;
          this.purchase.inventory_id = params.id || 0;
          this.size.model_id = params.id || 0;
          this.production_user.production_id = params.id || 0;
          this.production_model.production_id = params.id || 0;

          this.form.id = params.id || 0;
          this.form.model_id = params.model_id ?? null;
          this.form.description = params.description || '';
          this.form.status = params.status || 0;
          this.form.delivery_date = params.delivery_date || '';
          this.form.price = params.price || params.model?.price || 0;
          this.form.selling_cost = params.selling_cost || 0;
          this.form.wholesale_price = params.wholesale_price || 0;
          this.form.retail_price = params.retail_price || 0;
          this.form.oficio_id = params.oficio_id ? parseInt(params.oficio_id) : null;
          this.form.bodega_id = params.bodega_id ? parseInt(params.bodega_id) : null;
          this.form.etapa = params.etapa || '';
          this.modal.project_id = params.id || 0;
        }

        // Cargar datos base del card principal (modelos, oficios, bodegas, insumos)
        await Promise.all([
          this.getModels(),
          this.getOficios(),
          this.getBodegas(),
          this.getAllInsumos(),
        ]);

        // Solo cargar tallas si hay un modelo seleccionado
        if (this.form.model_id) {
          await this.getSizes();
        }

        // Configurar Select2 una vez que los datos estén cargados
        this.$nextTick(() => {
          $(this.$refs.modelSelect).select2({
            placeholder: 'Seleccione un modelo',
            allowClear: false,
          }).on('change', () => {
            const selectedModelId = $(this.$refs.modelSelect).val();
            this.form.model_id = selectedModelId;
            
            if (selectedModelId) {
              const selectedModel = this.models.find(model => model.id == selectedModelId);
              if (selectedModel && selectedModel.price) {
                this.form.price = selectedModel.price;
              } else {
                this.form.price = 0;
              }
            } else {
              this.form.price = 0;
            }
          });

          if (this.form.model_id) {
            $(this.$refs.modelSelect).val(this.form.model_id).trigger('change');
          }
          this.syncModelSelectDisabledState();

          $(this.$refs.modelUserSelect).select2({
            placeholder: 'Seleccione un modelo',
            allowClear: false,
            dropdownParent: $('#ModalBudget .modal-body'),
          }).on('change', () => {
            this.production_user.production_models_id = $(this.$refs.modelUserSelect).val();

            this.$nextTick(() => {


              let modelo = this.insumos.filter(insumo =>
                insumo.id === parseInt(this.production_user?.production_models_id)
              );


              if (parseInt(this.production_user.production_models_id) === 0) {
                this.production_user.received_quantity = this.insumos.reduce((acc, item) => acc + item.quantity_to_produce, 0);
                this.total_modal_quantity = this.production_user.received_quantity;
              } else {

                if (modelo[0] && modelo[0].quantity_to_produce) {

                  console.log(modelo);
                  console.log(modelo[0]);
                  console.log(modelo[0].quantity_to_produce);

                  this.production_user.received_quantity = modelo[0].quantity_to_produce;
                  this.total_modal_quantity = this.production_user.received_quantity;
                }
              }

              this.validateQuantity();

            });

            const val = $(this.$refs.modelUserSelect).val();
            this.oficio_id = parseInt(val);


          });

          $(this.$refs.sizesSelect).select2({
            placeholder: 'Seleccione una o más tallas y colores',
            allowClear: true,
            multiple: true,
            dropdownParent: $('#ModalModel .modal-body'),
          }).on('change', () => {
          });

          $(this.$refs.usersSelect).select2({
            placeholder: 'Seleccione un usuario',
            allowClear: false,
            dropdownParent: $('#ModalBudget .modal-body'),
          }).on('change', () => {
            this.production_user.user_id = $(this.$refs.usersSelect).val();

            this.fieldPayment = true;

          });

          $(this.$refs.processesSelect).select2({
            placeholder: 'Filtrar por oficio',
            dropdownParent: $('#ModalBudget .modal-body'),
          }).on('change', (event) => {
            this.oficio_id = $(event.target).val();
            this.filterUsersByOficio();
          });

          // Inicializar Select2 para etapa
          if (this.$refs.etapaSelect) {
            $(this.$refs.etapaSelect).select2({
              placeholder: 'Seleccionar etapa',
              allowClear: true,
            }).on('change', () => {
              this.form.etapa = $(this.$refs.etapaSelect).val() || '';
              this.handleEtapaChange();
            });
            if (this.form.etapa) {
              $(this.$refs.etapaSelect).val(this.form.etapa).trigger('change');
            }
          }
        });

        // === Cerrar el modal de carga: el card principal ya está listo ===
        Swal.close();

        // === FASE 2: Cargar cards secundarios con spinners ===
        if (isEditing && this.form.id) {
          // Cargar en paralelo: insumos, usuarios asignados, novedades
          // Cada card muestra su propio spinner mientras carga
          this.getInsumos();
          this.getData();
          this.getNovelties();
          this.getUsers();
        }

      } catch (error) {
        console.error("Error al cargar los datos:", error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Hubo un problema al cargar los datos. Por favor, inténtalo nuevamente.',
        });
      }
    })();

    // Cargar configuración de beneficios
    await this.loadSettings();

    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {

    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    // Destruir Select2 del select de modelo
    if (this.$refs.modelSelect && $(this.$refs.modelSelect).hasClass('select2-hidden-accessible')) {
      $(this.$refs.modelSelect).select2('destroy');
    }
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>

<style>
.disabled-link {
  color: gray;
  pointer-events: none;
  /* Impide la interacción */
  cursor: not-allowed;
  /* Cambia el cursor para indicar que está deshabilitado */
}

/* Quitar el borde inferior de las filas de la tabla */
.accordion-body .table > :not(caption) > * > * {
  border-bottom-width: 0 !important;
}
</style>
